import * as i1$1 from '@angular/common';
import { CommonModule, Location, NgTemplateOutlet, KeyValuePipe, UpperCasePipe } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, DestroyRef, Component, Injectable, signal, computed, Pipe, EventEmitter, Output, Input, InjectionToken, effect, untracked, ViewChild, ViewChildren, HostListener, input } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, NavigationEnd, RouterOutlet, RouterLink } from '@angular/router';
import * as i1 from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { IconComponent, ComponentsGlobalWebModule, GarminGlobalStoreService, GButton, ModalComponent, SortableColumnHeaderComponent, SearchInputComponent, Permission, WizardState, InsigniaBreakpoints, UnsavedChanges, WizardHeaderComponent, emailRegEx, FeatureFlyGarmin, FeatureFlyAdmin, unsavedChangesGuard } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { filter, switchMap, throwError, of, Subject, EMPTY, tap, merge, catchError, shareReplay, map, forkJoin, defaultIfEmpty, fromEvent, debounceTime, concatMap, take, timeout, isEmpty } from 'rxjs';
import * as i2 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CustomerReadOnlyControllerService } from '@garmin-avcloud/avcloud-fly-web-common/api/customer/read';
import { OrganizationWriteControllerService, RoleWriteControllerService, MembershipWriteControllerService, MembershipInviteWriteControllerService } from '@garmin-avcloud/avcloud-fly-web-common/api/orgs-roles/write';
import { HttpHeaders, HttpContextToken, HttpContext, HttpStatusCode } from '@angular/common/http';
import { OrganizationReadOnlyControllerService, RoleReadOnlyControllerService, PermissionReadOnlyControllerService, MembershipReadOnlyControllerService, AuthorizationReadOnlyControllerService, MembershipInviteReadOnlyControllerService } from '@garmin-avcloud/avcloud-fly-web-common/api/orgs-roles/read';
import { LocalStorageService, CookieService, LocalStorageKey } from '@garmin-avcloud/avcloud-web-utils';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
import { AircraftReadOnlyControllerService } from '@garmin-avcloud/avcloud-fly-web-common/api/aircraft/read';
import { PossessiveNounPipe } from '@garmin-avcloud/avcloud-fly-web-common/_shared';
import { FeaturesService } from '@garmin-avcloud/avcloud-web-utils/feature';
function OrgComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function OrgComponent_Conditional_1_Template_button_click_0_listener() {
      const back_r2 = i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.router.navigate([back_r2], {
        relativeTo: ctx_r2.activatedRoute
      }));
    });
    i0.ɵɵelement(1, "fly-icon", 3);
    i0.ɵɵtext(2, " Back ");
    i0.ɵɵelementEnd();
  }
}
function OrgComponent_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "/");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r4, " ");
  }
}
function OrgComponent_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(breadcrumb_r4);
  }
}
function OrgComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrgComponent_For_4_Conditional_0_Template, 4, 1)(1, OrgComponent_For_4_Conditional_1_Template, 2, 1, "strong");
  }
  if (rf & 2) {
    const ɵ$index_11_r5 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ɵ$index_11_r5 !== ctx_r2.routeData["breadcrumbs"].length - 1 ? 0 : 1);
  }
}
function CreateOrganizationComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.nameErrorString, " ");
  }
}
function CreateOrganizationComponent_For_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-chip");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "fly-icon", 18);
    i0.ɵɵlistener("click", function CreateOrganizationComponent_For_12_Template_fly_icon_click_2_listener() {
      const ɵ$index_23_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.emailDomains.splice(ɵ$index_23_r3, 1));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const domain_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", domain_r4, " ");
  }
}
function CreateOrganizationComponent_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.ownerEmailErrorString, " ");
  }
}
function CreateOrganizationComponent_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.creationErrorString, " ");
  }
}
const _forTrack0 = ($index, $item) => $item.uuid;
function OrgsSelectorComponent_For_24_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "flyUserRoleByOrgId");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const org_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, org_r2.uuid), " ");
  }
}
function OrgsSelectorComponent_For_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function OrgsSelectorComponent_For_24_Template_button_click_0_listener() {
      let tmp_11_0;
      const org_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClickSwitchOrgButton((tmp_11_0 = org_r2.uuid) !== null && tmp_11_0 !== undefined ? tmp_11_0 : null));
    });
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, OrgsSelectorComponent_For_24_Conditional_3_Template, 3, 3, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const org_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(org_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(org_r2.uuid ? 3 : -1);
  }
}
function OrgsSelectorComponent_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 1);
    i0.ɵɵtext(2, "PERSONAL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10)(4, "button", 12);
    i0.ɵɵlistener("click", function OrgsSelectorComponent_Conditional_25_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClickSwitchOrgButton(null));
    });
    i0.ɵɵtext(5, " To be implemented ");
    i0.ɵɵelement(6, "div", 4);
    i0.ɵɵelementEnd()()();
  }
}
function BasicOrgSettingsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-alert", 5);
    i0.ɵɵlistener("click", function BasicOrgSettingsComponent_Conditional_0_Template_g_alert_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickStatusBanner());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("closeable", true)("type", ((tmp_2_0 = ctx_r1.status()) == null ? null : tmp_2_0.type) != null ? (tmp_2_0 = ctx_r1.status()) == null ? null : tmp_2_0.type : "default");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_3_0 = ctx_r1.status()) == null ? null : tmp_3_0.message, " ");
  }
}
function BasicOrgSettingsComponent_Conditional_11_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 10);
    i0.ɵɵlistener("click", function BasicOrgSettingsComponent_Conditional_11_For_3_Template_button_click_3_listener() {
      const domain_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteDomain(domain_r5));
    });
    i0.ɵɵelement(4, "fly-icon", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const domain_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(domain_r5);
  }
}
function BasicOrgSettingsComponent_Conditional_11_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error");
    i0.ɵɵtext(1, "Invalid email domain");
    i0.ɵɵelementEnd();
  }
}
function BasicOrgSettingsComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section")(1, "div");
    i0.ɵɵrepeaterCreate(2, BasicOrgSettingsComponent_Conditional_11_For_3_Template, 5, 1, "div", 6, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "g-input", 7)(5, "input", 8);
    i0.ɵɵlistener("keydown.enter", function BasicOrgSettingsComponent_Conditional_11_Template_input_keydown_enter_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addDomain());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, BasicOrgSettingsComponent_Conditional_11_Conditional_6_Template, 2, 0, "g-error");
    i0.ɵɵelementStart(7, "p", 9);
    i0.ɵɵtext(8, "Press Enter to add domain");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.domains());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("error", (ctx_r1.domainInput.errors == null ? null : ctx_r1.domainInput.errors["email"]) === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.domainInput);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.domainInput.errors == null ? null : ctx_r1.domainInput.errors["email"]) === true ? 6 : -1);
  }
}
function PageControlsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 3);
    i0.ɵɵlistener("click", function PageControlsComponent_Conditional_3_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showAll.set(!ctx_r1.showAll()));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.showAll() ? "Hide" : "Show", " Full List ");
  }
}
function PageControlsComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-pagination", 4);
    i0.ɵɵlistener("g-page-changed", function PageControlsComponent_Conditional_4_Template_g_pagination_g_page_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("currentPage", ctx_r1.currentPage())("totalPages", ctx_r1.totalPages);
  }
}
const _forTrack1 = ($index, $item) => $item.id;
function PermissionCellComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " No Permission is assigned ");
    i0.ɵɵelementEnd();
  }
}
function PermissionCellComponent_Conditional_1_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" +", ctx_r0.otherPermissions.length, " more ");
  }
}
function PermissionCellComponent_Conditional_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PermissionCellComponent_Conditional_1_ng_template_0_Conditional_2_Template, 2, 1, "span", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.displayedPermission.category, " - ", ctx_r0.displayedPermission.title, "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.otherPermissions.length > 0 ? 2 : -1);
  }
}
function PermissionCellComponent_Conditional_1_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PermissionCellComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PermissionCellComponent_Conditional_1_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const heading_r2 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", heading_r2);
  }
}
function PermissionCellComponent_Conditional_1_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PermissionCellComponent_Conditional_1_Conditional_3_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const permission_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", permission_r3.category, " - ", permission_r3.title, "");
  }
}
function PermissionCellComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-collapsible-region", 1)(1, "div", 5);
    i0.ɵɵtemplate(2, PermissionCellComponent_Conditional_1_Conditional_3_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵrepeaterCreate(4, PermissionCellComponent_Conditional_1_Conditional_3_For_5_Template, 2, 2, "p", null, _forTrack1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const heading_r2 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("expanded", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", heading_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r0.otherPermissions);
  }
}
function PermissionCellComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PermissionCellComponent_Conditional_1_ng_template_0_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, PermissionCellComponent_Conditional_1_Conditional_2_Template, 1, 1, "ng-container")(3, PermissionCellComponent_Conditional_1_Conditional_3_Template, 6, 2, "g-collapsible-region", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.otherPermissions.length === 0 ? 2 : 3);
  }
}
const _c0 = ["modal"];
const _c1 = a0 => ({
  text: "Cancel",
  action: a0
});
const _c2 = a0 => ({
  text: "Remove",
  action: a0,
  primary: true
});
const _c3 = (a0, a1) => [a0, a1];
function RolesTableComponent_Conditional_0_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const permission_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", permission_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", permission_r2.category, " - ", permission_r2.title, "");
  }
}
function RolesTableComponent_Conditional_0_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const sort_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", sort_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", sort_r3, " ");
  }
}
function RolesTableComponent_Conditional_0_Conditional_21_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1, "No Search Results");
    i0.ɵɵelementEnd();
  }
}
function RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "g-button", 28);
    i0.ɵɵlistener("click", function RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template_g_button_click_1_listener() {
      let tmp_16_0;
      i0.ɵɵrestoreView(_r5);
      const roleSummary_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.navigateToEditRole((tmp_16_0 = roleSummary_r6.uuid) !== null && tmp_16_0 !== undefined ? tmp_16_0 : ""));
    });
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3, "EDIT");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "g-button", 30);
    i0.ɵɵlistener("click", function RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template_g_button_click_4_listener() {
      i0.ɵɵrestoreView(_r5);
      const roleSummary_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.removeRole(roleSummary_r6));
    });
    i0.ɵɵelementStart(5, "span", 29);
    i0.ɵɵtext(6, "REMOVE");
    i0.ɵɵelementEnd()()();
  }
}
function RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "strong", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "fly-permission-cell", 26);
    i0.ɵɵtemplate(6, RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template, 7, 0, "div", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const roleSummary_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(roleSummary_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(roleSummary_r6.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("roleSummary", roleSummary_r6);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.accessControls.canEditOrgRoles() ? 6 : -1);
  }
}
function RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Template, 7, 4, "div", 24, _forTrack0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r3.rolesTableService.currentPageRoles());
  }
}
function RolesTableComponent_Conditional_0_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RolesTableComponent_Conditional_0_Conditional_21_Conditional_0_Template, 2, 0, "div", 23)(1, RolesTableComponent_Conditional_0_Conditional_21_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.rolesTableService.currentPageRoles().length === 0 ? 0 : 1);
  }
}
function RolesTableComponent_Conditional_0_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-page-controls", 22);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("count", ctx_r3.rolesTableService.currentPageRoles().length)("total", ctx_r3.rolesTableService.filteredRoles().length)("currentPage", ctx_r3.rolesTableService.currentPage)("totalPages", ctx_r3.rolesTableService.totalPages())("showAll", ctx_r3.rolesTableService.showAll);
  }
}
function RolesTableComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "fly-search-input", 8);
    i0.ɵɵelementStart(3, "g-drop-down", 9)(4, "select", 10)(5, "option", 11);
    i0.ɵɵtext(6, " --Select Permission-- ");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(7, RolesTableComponent_Conditional_0_For_8_Template, 2, 3, "option", 12, _forTrack1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "g-drop-down", 13)(10, "select", 14);
    i0.ɵɵrepeaterCreate(11, RolesTableComponent_Conditional_0_For_12_Template, 2, 2, "option", 15, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div", 16)(14, "fly-sortable-column-header", 17);
    i0.ɵɵlistener("click", function RolesTableComponent_Conditional_0_Template_fly_sortable_column_header_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.rolesTableService.sortRoles("role"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "fly-sortable-column-header", 18);
    i0.ɵɵlistener("click", function RolesTableComponent_Conditional_0_Template_fly_sortable_column_header_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.rolesTableService.sortRoles("description"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 19);
    i0.ɵɵtext(17, "Permissions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "button", 20);
    i0.ɵɵlistener("click", function RolesTableComponent_Conditional_0_Template_button_click_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.loadRoles());
    });
    i0.ɵɵtext(19, " Refresh List ");
    i0.ɵɵelement(20, "fly-icon", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(21, RolesTableComponent_Conditional_0_Conditional_21_Template, 2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, RolesTableComponent_Conditional_0_Conditional_22_Template, 1, 5, "fly-page-controls", 22);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("inputControl", ctx_r3.rolesTableService.searchInput);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r3.rolesTableService.permissionSelection);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", null);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r3.permissionsService.permissions());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControl", ctx_r3.rolesTableService.sortBySelection);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.sortByOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("sortDir", ctx_r3.rolesTableService.sortDirRole);
    i0.ɵɵadvance();
    i0.ɵɵproperty("sortDir", ctx_r3.rolesTableService.sortDirDescription);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r3.state() === "LOADED" ? 21 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.state() === "LOADED" ? 22 : -1);
  }
}
function RolesTableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 1);
  }
}
function RolesTableComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "fly-icon", 31);
    i0.ɵɵelementStart(2, "div", 32)(3, "strong");
    i0.ɵɵtext(4, "Error loading roles list");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 33);
    i0.ɵɵtext(6, "Please refresh the page or press the button below.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "g-button", 34);
    i0.ɵɵlistener("click", function RolesTableComponent_Conditional_2_Template_g_button_click_7_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.loadRoles());
    });
    i0.ɵɵelementStart(8, "div", 35);
    i0.ɵɵelement(9, "fly-icon", 36);
    i0.ɵɵtext(10, " Refresh List ");
    i0.ɵɵelementEnd()()()();
  }
}
function RolesTableComponent_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtext(1, "Unable to remove role. Please try again!");
    i0.ɵɵelementEnd();
  }
}
function RolesTableComponent_Case_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "g-loader", 1);
    i0.ɵɵelementEnd();
  }
}
function OrgsCustomRolesComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "g-button", 2);
    i0.ɵɵlistener("click", function OrgsCustomRolesComponent_Conditional_6_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateToCreateRole());
    });
    i0.ɵɵtext(2, " CREATE NEW ROLE ");
    i0.ɵɵelementEnd()();
  }
}
function RoleDetailsComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error");
    i0.ɵɵtext(1, "A role with this name already exists.");
    i0.ɵɵelementEnd();
  }
}
const _c4 = ["*"];
const _c5 = () => ({
  "padding-left": "1rem",
  "padding-right": "1rem"
});
function RoleWizardStepPreviewCardFrameComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RoleWizardStepPreviewCardFrameComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-collapsible-region", 3);
    i0.ɵɵlistener("g-expand", function RoleWizardStepPreviewCardFrameComponent_Conditional_0_Template_g_collapsible_region_g_expand_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.roleWizardDataService.detailsCardExpandedState.set(true));
    })("g-collapse", function RoleWizardStepPreviewCardFrameComponent_Conditional_0_Template_g_collapsible_region_g_collapse_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.roleWizardDataService.detailsCardExpandedState.set(false));
    });
    i0.ɵɵtemplate(1, RoleWizardStepPreviewCardFrameComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const cardFrame_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("expanded", ctx_r1.roleWizardDataService.detailsCardExpandedState());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardFrame_r3);
  }
}
function RoleWizardStepPreviewCardFrameComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RoleWizardStepPreviewCardFrameComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, RoleWizardStepPreviewCardFrameComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const cardFrame_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardFrame_r3);
  }
}
function RoleWizardStepPreviewCardFrameComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h2", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 6)(3, "div", 7);
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "g-button", 8);
    i0.ɵɵlistener("click", function RoleWizardStepPreviewCardFrameComponent_ng_template_2_Template_g_button_click_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.roleWizardNavigationService.navigateTo(ctx_r1.roleWizardStep));
    });
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵelement(7, "fly-icon", 10);
    i0.ɵɵtext(8, " Edit ");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("styleObject", i0.ɵɵpureFunction0(2, _c5));
  }
}
const _forTrack2 = ($index, $item) => $item.key;
function RolePermissionsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.roleDescription);
  }
}
function RolePermissionsComponent_For_12_For_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const permission_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(permission_r5.description);
  }
}
function RolePermissionsComponent_For_12_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 13)(2, "h4", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "g-switch", 15)(5, "input", 16);
    i0.ɵɵlistener("change", function RolePermissionsComponent_For_12_For_6_Template_input_change_5_listener() {
      const permission_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.togglePermissionSelected(permission_r5));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, RolePermissionsComponent_For_12_For_6_Conditional_6_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const permission_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(permission_r5.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", permission_r5.id === ctx_r0.Permission.ORGANIZATION_READ || permission_r5.id === ctx_r0.Permission.MEMBER_READ || permission_r5.selected())("disabled", permission_r5.id === ctx_r0.Permission.ORGANIZATION_READ || permission_r5.id === ctx_r0.Permission.MEMBER_READ);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.areDescriptionsShown() ? 6 : -1);
  }
}
function RolePermissionsComponent_For_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "g-collapsible-region", 10);
    i0.ɵɵlistener("g-expand", function RolePermissionsComponent_For_12_Template_g_collapsible_region_g_expand_1_listener() {
      const categoryToPermissions_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.categoryExpandedStates()[categoryToPermissions_r3.key].set(true));
    })("g-collapse", function RolePermissionsComponent_For_12_Template_g_collapsible_region_g_collapse_1_listener() {
      const categoryToPermissions_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.categoryExpandedStates()[categoryToPermissions_r3.key].set(false));
    });
    i0.ɵɵelementStart(2, "h3", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵrepeaterCreate(5, RolePermissionsComponent_For_12_For_6_Template, 7, 4, "div", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const categoryToPermissions_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("expanded", ctx_r0.categoryExpandedStates()[categoryToPermissions_r3.key]());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", categoryToPermissions_r3.key, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(categoryToPermissions_r3.value);
  }
}
function RoleReviewComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.roleDescription);
  }
}
function RoleReviewComponent_For_13_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dd", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const permission_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(permission_r2.title);
  }
}
function RoleReviewComponent_For_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "dt", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, RoleReviewComponent_For_13_For_4_Template, 2, 1, "dd", 9, _forTrack1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const categoryToPermissions_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(categoryToPermissions_r3.key);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(categoryToPermissions_r3.value);
  }
}
const _c6 = ["createSubmissionModal"];
const _c7 = ["updateSubmissionModal"];
const _c8 = a0 => ({
  text: "No, go to home page",
  action: a0
});
const _c9 = a0 => ({
  text: "Yes, take me to member role assignment",
  action: a0,
  primary: true
});
const _c10 = a0 => ({
  text: "Yes, take me to role management",
  action: a0,
  primary: true
});
const _c11 = () => ({
  "padding-left": ".75rem",
  "padding-right": ".75rem"
});
const _c12 = a0 => ({
  disabled: a0
});
function RoleWizardComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 15);
    i0.ɵɵlistener("click", function RoleWizardComponent_ng_template_0_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.roleWizardNavigationService.goToPreviousStep());
    });
    i0.ɵɵtext(1, " Back ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("styleObject", i0.ɵɵpureFunction0(2, _c11))("disabled", ctx_r1.submitState() === "LOADING");
  }
}
function RoleWizardComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 16);
    i0.ɵɵlistener("click", function RoleWizardComponent_ng_template_2_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.roleWizardNavigationService.goToNextStep());
    });
    i0.ɵɵtext(1, " Next ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const disabled_r4 = ctx.disabled;
    i0.ɵɵproperty("disabled", disabled_r4)("styleObject", i0.ɵɵpureFunction0(2, _c5));
  }
}
function RoleWizardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-alert", 4)(1, "div", 17)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 18);
    i0.ɵɵlistener("click", function RoleWizardComponent_Conditional_4_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵtext(5, "TRY AGAIN");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.submitErrorText());
  }
}
function RoleWizardComponent_Case_13_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RoleWizardComponent_Case_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19)(1, "g-button", 20);
    i0.ɵɵtext(2, " Cancel ");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, RoleWizardComponent_Case_13_ng_container_3_Template, 1, 0, "ng-container", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const nextButton_r6 = i0.ɵɵreference(3);
    i0.ɵɵproperty("routerLink", ctx_r1.cancelRoute);
    i0.ɵɵadvance();
    i0.ɵɵproperty("styleObject", i0.ɵɵpureFunction0(4, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", nextButton_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c12, !ctx_r1.roleWizardDataService.roleNameInput.valid || ctx_r1.state() !== "LOADED"));
  }
}
function RoleWizardComponent_Case_14_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RoleWizardComponent_Case_14_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RoleWizardComponent_Case_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RoleWizardComponent_Case_14_ng_container_0_Template, 1, 0, "ng-container", 22)(1, RoleWizardComponent_Case_14_ng_container_1_Template, 1, 0, "ng-container", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const backButton_r7 = i0.ɵɵreference(1);
    const nextButton_r6 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", backButton_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nextButton_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c12, ctx_r1.roleWizardDataService.selectedPermissions().length === 0));
  }
}
function RoleWizardComponent_Case_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RoleWizardComponent_Case_15_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 25);
  }
}
function RoleWizardComponent_Case_15_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.submitButtonText(), " ");
  }
}
function RoleWizardComponent_Case_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, RoleWizardComponent_Case_15_ng_container_0_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementStart(1, "g-button", 23);
    i0.ɵɵlistener("click", function RoleWizardComponent_Case_15_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(2, "div", 24);
    i0.ɵɵtemplate(3, RoleWizardComponent_Case_15_Conditional_3_Template, 1, 0, "g-loader", 25)(4, RoleWizardComponent_Case_15_Conditional_4_Template, 1, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const backButton_r7 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", backButton_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("styleObject", i0.ɵɵpureFunction0(4, _c5))("disabled", ctx_r1.submitState() === "LOADING");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.submitState() === "LOADING" ? 3 : 4);
  }
}
function RoleWizardComponent_Case_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 10);
  }
}
function RoleWizardComponent_Case_17_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-role-details");
  }
}
function RoleWizardComponent_Case_17_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-role-permissions");
  }
}
function RoleWizardComponent_Case_17_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-role-review");
  }
}
function RoleWizardComponent_Case_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RoleWizardComponent_Case_17_Case_0_Template, 1, 0, "fly-role-details")(1, RoleWizardComponent_Case_17_Case_1_Template, 1, 0, "fly-role-permissions")(2, RoleWizardComponent_Case_17_Case_2_Template, 1, 0, "fly-role-review");
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.roleWizardNavigationService.step()) === ctx_r1.RoleWizardStep.Details ? 0 : tmp_5_0 === ctx_r1.RoleWizardStep.Permissions ? 1 : tmp_5_0 === ctx_r1.RoleWizardStep.Review ? 2 : -1);
  }
}
function RoleWizardComponent_Case_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error", 11);
    i0.ɵɵtext(1, "An error occurred while loading the role. Please refresh the page and try again.");
    i0.ɵɵelementEnd();
  }
}
function InvitationModalComponent_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-orgs-email-pill", 24);
    i0.ɵɵlistener("closeClicked", function InvitationModalComponent_For_10_Template_fly_orgs_email_pill_closeClicked_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeEmail($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const email_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", email_r4)("hidden", ctx_r2.state === "error" || ctx_r2.state === "submitted");
  }
}
function InvitationModalComponent_For_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const role_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", role_r5.uuid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", role_r5.name, " ");
  }
}
function InvitationModalComponent_Conditional_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("NOTE: Everyone invited above will be assigned the role of ", ctx_r2.selectedRole.name, ".");
  }
}
function InvitationModalComponent_Case_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "g-loader", 25);
    i0.ɵɵelementEnd();
  }
}
function InvitationModalComponent_Case_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " INVITE ");
  }
}
function PendingInvitationsTableComponent_For_7_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const role_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(role_r1.name);
  }
}
function PendingInvitationsTableComponent_For_7_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "g-button", 8);
    i0.ɵɵlistener("click", function PendingInvitationsTableComponent_For_7_Conditional_6_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const invite_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.deleteInvite(invite_r3));
    });
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "DELETE");
    i0.ɵɵelementEnd()()();
  }
}
function PendingInvitationsTableComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵrepeaterCreate(4, PendingInvitationsTableComponent_For_7_For_5_Template, 2, 1, "span", null, _forTrack0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PendingInvitationsTableComponent_For_7_Conditional_6_Template, 4, 0, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const invite_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(invite_r3.recipientEmailAddress);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(invite_r3.roles);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r3.accessControls.canDeleteOrgMembershipInvites() ? 6 : -1);
  }
}
function PendingInvitationsTableComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "fly-icon", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.errorText, " ");
  }
}
function PendingInvitationsComponent_Case_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 6);
    i0.ɵɵlistener("click", function PendingInvitationsComponent_Case_5_Conditional_4_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.invitationModal == null ? null : ctx_r1.invitationModal.open());
    });
    i0.ɵɵtext(1, " SEND AN INVITE TO JOIN ");
    i0.ɵɵelementEnd();
  }
}
function PendingInvitationsComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-orgs-pending-invites-table", 3);
    i0.ɵɵelementStart(1, "div", 4)(2, "span");
    i0.ɵɵtext(3, "No pending invites");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PendingInvitationsComponent_Case_5_Conditional_4_Template, 2, 0, "g-button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r1.service.pendingInvites() == null || ctx_r1.service.pendingInvites().length <= 0);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("hidden", !(ctx_r1.service.pendingInvites() == null || ctx_r1.service.pendingInvites().length <= 0));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.accessControl.canCreateOrgMembershipInvites() ? 4 : -1);
  }
}
function PendingInvitationsComponent_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 2);
  }
}
function PendingInvitationsComponent_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "hr");
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelement(2, "fly-icon", 8);
    i0.ɵɵelementStart(3, "div")(4, "strong");
    i0.ɵɵtext(5, "Error loading pending invites list.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Please refresh the page or press the button below.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "g-button", 9);
    i0.ɵɵlistener("click", function PendingInvitationsComponent_Case_7_Template_g_button_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.load());
    });
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵelement(10, "fly-icon", 11);
    i0.ɵɵtext(11, " Refresh List ");
    i0.ɵɵelementEnd()()()();
  }
}
function PendingInvitationsComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-orgs-invitation-modal", null, 0);
  }
}
function AddRolesComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵtext(1, "No roles available");
    i0.ɵɵelementEnd();
  }
}
function AddRolesComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div")(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "button", 5);
    i0.ɵɵlistener("click", function AddRolesComponent_For_6_Template_button_click_4_listener() {
      const role_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClickAddRoleButton(role_r2));
    });
    i0.ɵɵelement(5, "fly-icon", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const role_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(role_r2.name);
  }
}
function AssignedRolesComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵtext(1, "At least one role must be assigned!");
    i0.ɵɵelementEnd();
  }
}
function AssignedRolesComponent_For_7_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function AssignedRolesComponent_For_7_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const role_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClickRemoveRoleButton(role_r2));
    });
    i0.ɵɵelement(1, "fly-icon", 7);
    i0.ɵɵelementEnd();
  }
}
function AssignedRolesComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div")(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, AssignedRolesComponent_For_7_Conditional_4_Template, 2, 0, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const role_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(role_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(role_r2.uuid !== ctx_r2.OWNER_ROLE.uuid ? 4 : -1);
  }
}
function OrgsEditRolesComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function OrgsEditRolesComponent_Conditional_14_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickCancelButton());
    });
    i0.ɵɵtext(2, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "g-button", 7);
    i0.ɵɵlistener("click", function OrgsEditRolesComponent_Conditional_14_Template_g_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickSaveRolesButton());
    });
    i0.ɵɵtext(4, " Save Roles ");
    i0.ɵɵelementEnd()();
  }
}
function DetailsCardComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵelement(2, "g-loader", 3);
    i0.ɵɵelementEnd()();
  }
}
function DetailsCardComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, "An error has occurred. Please reload the page.");
    i0.ɵɵelementEnd();
  }
}
function DetailsCardComponent_Case_5_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.additionalText);
  }
}
function DetailsCardComponent_Case_5_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function DetailsCardComponent_Case_5_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.secondaryButtonClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.linkText, " ");
  }
}
function DetailsCardComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "span", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "uppercase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, DetailsCardComponent_Case_5_Conditional_6_Template, 2, 1, "p");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span")(8, "g-button", 6);
    i0.ɵɵlistener("click", function DetailsCardComponent_Case_5_Template_g_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.primaryButtonClicked.emit());
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, DetailsCardComponent_Case_5_Conditional_10_Template, 2, 1, "button", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.count);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, ctx_r1.units));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.additionalText != null ? 6 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.linkText != null ? 10 : -1);
  }
}
function OrganizationLandingComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 7);
    i0.ɵɵlistener("click", function OrganizationLandingComponent_Conditional_6_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.router.navigate(["./settings"], {
        relativeTo: ctx_r1.activatedRoute
      }));
    });
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "fly-icon", 9);
    i0.ɵɵtext(3, " Settings ");
    i0.ɵɵelementEnd()();
  }
}
function OrganizationLandingComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-details-card", 10);
    i0.ɵɵlistener("primaryButtonClicked", function OrganizationLandingComponent_Conditional_8_Template_fly_details_card_primaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.router.navigate(["./members"], {
        relativeTo: ctx_r1.activatedRoute
      }));
    })("secondaryButtonClicked", function OrganizationLandingComponent_Conditional_8_Template_fly_details_card_secondaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.invitationModal == null ? null : ctx_r1.invitationModal.open());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("count", ctx_r1.memberCount())("componentState", ctx_r1.membersState())("units", ctx_r1.memberCount() === 1 ? "Member" : "Members")("additionalText", ctx_r1.pendingInvitesText())("buttonText", ctx_r1.accessControls.canDeleteOrgMemberships() ? "Manage" : "View")("linkText", ctx_r1.accessControls.canCreateOrgMembershipInvites() ? "Invite People to Join" : undefined);
  }
}
function OrganizationLandingComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-details-card", 11);
    i0.ɵɵlistener("primaryButtonClicked", function OrganizationLandingComponent_Conditional_9_Template_fly_details_card_primaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.routeToAircraftList());
    })("secondaryButtonClicked", function OrganizationLandingComponent_Conditional_9_Template_fly_details_card_secondaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.routeToAddAircraft());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("count", ctx_r1.aircraftCount())("componentState", ctx_r1.aircraftState())("buttonText", ctx_r1.accessControls.canEditOrgAircraft() ? "Manage" : "View")("linkText", ctx_r1.addNewAircraftText());
  }
}
function OrganizationLandingComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-details-card", 12);
    i0.ɵɵlistener("primaryButtonClicked", function OrganizationLandingComponent_Conditional_10_Template_fly_details_card_primaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.router.navigate(["./roles"], {
        relativeTo: ctx_r1.activatedRoute
      }));
    })("secondaryButtonClicked", function OrganizationLandingComponent_Conditional_10_Template_fly_details_card_secondaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.router.navigate(["./roles/create"], {
        relativeTo: ctx_r1.activatedRoute
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("count", ctx_r1.customRoleSummariesCount())("componentState", ctx_r1.roleSummariesState())("units", ctx_r1.customRoleSummariesCount() === 1 ? "Role" : "Roles")("buttonText", ctx_r1.accessControls.canEditOrgRoles() ? "Manage" : "View")("linkText", ctx_r1.accessControls.canEditOrgRoles() ? "Create a New Role" : undefined);
  }
}
function OrganizationLandingComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-orgs-invitation-modal", null, 0);
  }
}
function RolesCellComponent_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" +", ctx_r0.otherRoles.length, " more ");
  }
}
function RolesCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, RolesCellComponent_ng_template_0_Conditional_2_Template, 2, 1, "span", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.displayedRole.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.otherRoles.length !== 0 ? 2 : -1);
  }
}
function RolesCellComponent_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RolesCellComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RolesCellComponent_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const heading_r2 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", heading_r2);
  }
}
function RolesCellComponent_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RolesCellComponent_Conditional_3_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const role_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(role_r3.name);
  }
}
function RolesCellComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-collapsible-region", 1)(1, "div", 6);
    i0.ɵɵtemplate(2, RolesCellComponent_Conditional_3_ng_container_2_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵrepeaterCreate(4, RolesCellComponent_Conditional_3_For_5_Template, 2, 1, "p", null, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const heading_r2 = i0.ɵɵreference(1);
    i0.ɵɵproperty("expanded", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", heading_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r0.otherRoles);
  }
}
function RolesCellComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵtext(1, " Change Roles ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", "./edit-roles/" + ctx_r0.member.customerGuid);
  }
}
const _forTrack3 = ($index, $item) => $item.customerGuid;
function MembersTableComponent_Conditional_0_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const role_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", role_r2.uuid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", role_r2.name, " ");
  }
}
function MembersTableComponent_Conditional_0_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const sort_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", sort_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", sort_r3, " ");
  }
}
function MembersTableComponent_Conditional_0_Conditional_21_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, "No Search Results");
    i0.ɵɵelementEnd();
  }
}
function MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "g-button", 26);
    i0.ɵɵlistener("click", function MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const member_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.removeMember(member_r6));
    });
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵtext(3, "REMOVE");
    i0.ɵɵelementEnd()()();
  }
}
function MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "strong", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "fly-roles-cell", 24);
    i0.ɵɵtemplate(6, MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Conditional_6_Template, 4, 0, "div", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const member_r6 = ctx.$implicit;
    const ɵ$index_47_r7 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(member_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(member_r6.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("member", member_r6);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.accessControls.canDeleteOrgMemberships() && ɵ$index_47_r7 !== ctx_r3.orgOwnerIndex() ? 6 : -1);
  }
}
function MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_For_1_Template, 7, 4, "div", 22, _forTrack3);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r3.membersTableService.currentPageMembers());
  }
}
function MembersTableComponent_Conditional_0_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MembersTableComponent_Conditional_0_Conditional_21_Conditional_0_Template, 2, 0, "div", 21)(1, MembersTableComponent_Conditional_0_Conditional_21_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.membersTableService.currentPageMembers().length === 0 ? 0 : 1);
  }
}
function MembersTableComponent_Conditional_0_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-page-controls", 20);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("count", ctx_r3.membersTableService.currentPageMembers().length)("total", ctx_r3.membersTableService.filteredMembers().length)("currentPage", ctx_r3.membersTableService.currentPage)("totalPages", ctx_r3.membersTableService.totalPages())("showAll", ctx_r3.membersTableService.showAll);
  }
}
function MembersTableComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵelement(2, "fly-search-input", 7);
    i0.ɵɵelementStart(3, "g-drop-down", 8)(4, "select", 9)(5, "option", 10);
    i0.ɵɵtext(6, " --Select Role-- ");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(7, MembersTableComponent_Conditional_0_For_8_Template, 2, 2, "option", 11, _forTrack0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "g-drop-down", 12)(10, "select", 13);
    i0.ɵɵrepeaterCreate(11, MembersTableComponent_Conditional_0_For_12_Template, 2, 2, "option", 11, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div", 14)(14, "fly-sortable-column-header", 15);
    i0.ɵɵlistener("click", function MembersTableComponent_Conditional_0_Template_fly_sortable_column_header_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.membersTableService.sortMembers("name"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "fly-sortable-column-header", 16);
    i0.ɵɵlistener("click", function MembersTableComponent_Conditional_0_Template_fly_sortable_column_header_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.membersTableService.sortMembers("email"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 17);
    i0.ɵɵtext(17, "Roles");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "button", 18);
    i0.ɵɵlistener("click", function MembersTableComponent_Conditional_0_Template_button_click_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.loadMembers());
    });
    i0.ɵɵtext(19, " Refresh List ");
    i0.ɵɵelement(20, "fly-icon", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(21, MembersTableComponent_Conditional_0_Conditional_21_Template, 2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, MembersTableComponent_Conditional_0_Conditional_22_Template, 1, 5, "fly-page-controls", 20);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("inputControl", ctx_r3.searchInput);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r3.roleSelection);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r3.rolesService.roles());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControl", ctx_r3.membersTableService.sortBySelection);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.sortByOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("sortDir", ctx_r3.membersTableService.sortDirName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("sortDir", ctx_r3.membersTableService.sortDirEmail);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r3.state() === "LOADED" ? 21 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.state() === "LOADED" ? 22 : -1);
  }
}
function MembersTableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 1);
  }
}
function MembersTableComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "fly-icon", 28);
    i0.ɵɵelementStart(2, "div", 29)(3, "strong");
    i0.ɵɵtext(4, "Error loading members list");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 30);
    i0.ɵɵtext(6, "Please refresh the page or press the button below.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "g-button", 31);
    i0.ɵɵlistener("click", function MembersTableComponent_Conditional_2_Template_g_button_click_7_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.loadMembers());
    });
    i0.ɵɵelementStart(8, "div", 32);
    i0.ɵɵelement(9, "fly-icon", 33);
    i0.ɵɵtext(10, " Refresh List ");
    i0.ɵɵelementEnd()()()();
  }
}
function MembersTableComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵtext(1, "Unable to remove member. Please try again.");
    i0.ɵɵelementEnd();
  }
}
function MembersTableComponent_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "g-loader", 1);
    i0.ɵɵelementEnd();
  }
}
function OrgsMembersComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 5);
    i0.ɵɵlistener("click", function OrgsMembersComponent_Conditional_6_Conditional_1_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.invitationModal == null ? null : ctx_r1.invitationModal.open());
    });
    i0.ɵɵtext(1, " SEND AN INVITE TO JOIN ");
    i0.ɵɵelementEnd();
  }
}
function OrgsMembersComponent_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵtext(1, " View Pending Invites ");
    i0.ɵɵelementEnd();
  }
}
function OrgsMembersComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, OrgsMembersComponent_Conditional_6_Conditional_1_Template, 2, 0, "g-button", 3)(2, OrgsMembersComponent_Conditional_6_Conditional_2_Template, 2, 0, "a", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.accessControls.canCreateOrgMembershipInvites() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.accessControls.canViewOrgMembershipInvites() ? 2 : -1);
  }
}
function OrgsMembersComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-orgs-invitation-modal", null, 0);
  }
}
let OrgComponent = /*#__PURE__*/(() => {
  class OrgComponent {
    constructor() {
      this.activatedRoute = inject(ActivatedRoute);
      this.router = inject(Router);
      this.destroyRef = inject(DestroyRef);
      this.routeData = {};
    }
    ngOnInit() {
      this.getRouteData(); // the first time we load this component, get the current breadcrumb
      // any time we navigate to other org components, update the breadcrumb
      this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.getRouteData());
    }
    getRouteData() {
      // the activated route is always this "parent" component, so we need to check
      // the `children` property to get the child that is currently active, which is
      // always the last one in the `children` list -- technically our OrgsRoutes
      // Routes have no children themselves so the `children` list here will always only
      // have a single ActivatedRoute, but we use -1 as the index simply to show the
      // intent of doing this correctly (i.e., we could just get index 0)
      this.routeData = this.activatedRoute.children.at(-1)?.routeConfig?.data ?? {};
      // Handling special case for Role wizard
      // If the user arrives from the legacy pages, directly accesses the page, or reloads it, only the "Current Page" breadcrumb should be displayed. The "Back" button should take the user to the Organizations' landing page.
      // However, if the user comes from the Roles table page, the breadcrumb should show "Roles / Current Page" and the "Back" button should return the user to the Roles table.
      const navigation = this.router.getCurrentNavigation();
      if (navigation?.extras?.state != null) {
        const {
          breadcrumbs,
          back
        } = navigation.extras.state;
        if (back != null && breadcrumbs != null) {
          this.routeData = {
            ...this.routeData,
            breadcrumbs: [...breadcrumbs],
            back: back
          };
        }
      }
    }
    static {
      this.ɵfac = function OrgComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrgComponent,
        selectors: [["fly-org"]],
        decls: 6,
        vars: 1,
        consts: [[1, "back"], [1, "breadcrumb"], [1, "back", 3, "click"], ["icon", "chevron-left", 1, "icon"]],
        template: function OrgComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "nav");
            i0.ɵɵtemplate(1, OrgComponent_Conditional_1_Template, 3, 0, "button", 0);
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵrepeaterCreate(3, OrgComponent_For_4_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(5, "router-outlet");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_0_0 = ctx.routeData["back"]) ? 1 : -1, tmp_0_0);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.routeData["breadcrumbs"]);
          }
        },
        dependencies: [CommonModule, RouterOutlet, IconComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;gap:.5rem;position:relative}nav[_ngcontent-%COMP%]{align-self:center}nav[_ngcontent-%COMP%]   .back[_ngcontent-%COMP%]{position:absolute;left:0;cursor:pointer;display:flex;gap:.5rem}nav[_ngcontent-%COMP%]   .back[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{color:#000;width:1rem;height:1rem}nav[_ngcontent-%COMP%]   .breadcrumb[_ngcontent-%COMP%]{display:flex;gap:.5rem}"]
      });
    }
  }
  return OrgComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrgCreateService = /*#__PURE__*/(() => {
  class OrgCreateService {
    constructor() {
      this.customerReadService = inject(CustomerReadOnlyControllerService);
      this.destroyRef = inject(DestroyRef);
      this.orgsWriteService = inject(OrganizationWriteControllerService);
    }
    /**
     * Creates a new organization.
     *
     * @param org the basic info necessary for creating the organization
     * @param ownerEmail email of the owner who will be assigned to the organization
     * @param allowedEmailDomains optional list of email domain strings
     * @returns the created OrganizationSummary if successful, or null
     * if the owner email is not found
     */
    create(org, ownerEmail, allowedEmailDomains) {
      return this.customerReadService.searchGarminCustomersPost({
        email: ownerEmail
      }).pipe(switchMap(customerAccounts => {
        return customerAccounts.length > 0 ? this.orgsWriteService.createOrganizationWithOwnership({
          ...org,
          // Emails are unique so only 1 account should come back
          ownerCustomerGuid: customerAccounts[0].id,
          allowedEmailDomains
        }) : throwError(() => new Error(`Customer with email ${ownerEmail} does not exist`));
      }), takeUntilDestroyed(this.destroyRef));
    }
    static {
      this.ɵfac = function OrgCreateService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgCreateService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OrgCreateService,
        factory: OrgCreateService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OrgCreateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CreateOrganizationComponent = /*#__PURE__*/(() => {
  class CreateOrganizationComponent {
    constructor() {
      this.domainsFocused = signal(false);
      this.emailDomains = [];
      this.formGroup = new FormGroup({
        name: new FormControl('', Validators.required),
        domain: new FormControl(''),
        allowGlobalInviteClaiming: new FormControl(false),
        ownerEmail: new FormControl('', [Validators.required, Validators.email])
      });
      this.nameErrorString = null;
      this.ownerEmailErrorString = null;
      this.creationErrorString = null;
      this.location = inject(Location);
      this.orgCreateService = inject(OrgCreateService);
      this.router = inject(Router);
      this.destroyRef = inject(DestroyRef);
    }
    /**
     * Called when pressing Enter while the "domains" control is
     * focused.
     */
    addEmailDomain() {
      const newDomain = this.formGroup.controls.domain.value;
      if (newDomain != null && newDomain.trim() !== '') {
        if (this.emailDomains.includes(newDomain)) {
          console.error('Domain', newDomain, 'already exists');
        } else {
          this.emailDomains.push(newDomain);
        }
        this.formGroup.controls.domain.setValue(null);
      }
    }
    /**
     * Called when the SUBMIT button is pressed.
     */
    createOrganization() {
      const updateControl = control => {
        if (control.errors != null) {
          if (control.errors['email'] != null) return 'Please enter a valid email address';
          if (control.errors['required'] != null) return 'This field is required';
          return 'Unknown error. Please try again';
        }
        return null;
      };
      this.nameErrorString = updateControl(this.formGroup.controls.name);
      this.ownerEmailErrorString = updateControl(this.formGroup.controls.ownerEmail);
      if (this.formGroup.valid) {
        this.orgCreateService.create({
          name: this.formGroup.value.name,
          allowGlobalInviteClaiming: this.formGroup.value.allowGlobalInviteClaiming
        }, this.formGroup.value.ownerEmail, this.emailDomains).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
          next: createdOrg => {
            this.creationErrorString = null;
            this.router.navigate([`/orgs/${createdOrg.uuid}`]);
          },
          error: e => {
            if (e.message.startsWith('Customer with email')) {
              this.ownerEmailErrorString = e.message;
              this.creationErrorString = null;
            } else {
              this.creationErrorString = 'Unable to create organization';
            }
          }
        });
      }
    }
    static {
      this.ɵfac = function CreateOrganizationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreateOrganizationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CreateOrganizationComponent,
        selectors: [["fly-orgs-create"]],
        decls: 28,
        vars: 6,
        consts: [[3, "formGroup"], ["label", "Organization Name", "labelFor", "name", "required", ""], ["formControlName", "name", "id", "name", "aria-describedby", "org-name-errors"], ["id", "org-name-errors"], [1, "input"], ["for", "domains"], [1, "domains-list"], ["formControlName", "domain", "id", "domains", 3, "blur", "focus", "keydown.enter"], [1, "subtext"], ["label", "Allow global invite claiming"], ["formControlName", "allowGlobalInviteClaiming", "type", "checkbox"], ["label", "Owner Email", "labelFor", "ownerEmail", "required", ""], ["formControlName", "ownerEmail", "aria-describedby", "owner-email-errors"], ["id", "owner-email-errors"], [1, "error"], [1, "buttons"], ["type", "button", 3, "click"], ["type", "button", 1, "cancel-button", 3, "click"], ["icon", "close", "slot", "trailing-icon", 1, "delete-pill", 3, "click"]],
        template: function CreateOrganizationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2");
            i0.ɵɵtext(1, "CREATE ORGANIZATION");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "form", 0)(3, "div")(4, "g-input", 1);
            i0.ɵɵelement(5, "input", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CreateOrganizationComponent_Conditional_6_Template, 2, 1, "g-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 4)(8, "label", 5);
            i0.ɵɵtext(9, "Allowed Email Domains");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 6);
            i0.ɵɵrepeaterCreate(11, CreateOrganizationComponent_For_12_Template, 3, 1, "g-chip", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementStart(13, "input", 7);
            i0.ɵɵlistener("blur", function CreateOrganizationComponent_Template_input_blur_13_listener() {
              return ctx.domainsFocused.set(false);
            })("focus", function CreateOrganizationComponent_Template_input_focus_13_listener() {
              return ctx.domainsFocused.set(true);
            })("keydown.enter", function CreateOrganizationComponent_Template_input_keydown_enter_13_listener() {
              return ctx.addEmailDomain();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "p", 8);
            i0.ɵɵtext(15, "Press Enter to add");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "g-checkbox", 9);
            i0.ɵɵelement(17, "input", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div")(19, "g-input", 11);
            i0.ɵɵelement(20, "input", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(21, CreateOrganizationComponent_Conditional_21_Template, 2, 1, "g-error", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, CreateOrganizationComponent_Conditional_22_Template, 2, 1, "div", 14);
            i0.ɵɵelementStart(23, "div", 15)(24, "g-button", 16);
            i0.ɵɵlistener("click", function CreateOrganizationComponent_Template_g_button_click_24_listener() {
              return ctx.createOrganization();
            });
            i0.ɵɵtext(25, " Submit ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(26, "button", 17);
            i0.ɵɵlistener("click", function CreateOrganizationComponent_Template_button_click_26_listener() {
              return ctx.location.back();
            });
            i0.ɵɵtext(27, " Cancel ");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.formGroup);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.nameErrorString ? 6 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵclassProp("focus", ctx.domainsFocused());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.emailDomains);
            i0.ɵɵadvance(10);
            i0.ɵɵconditional(ctx.ownerEmailErrorString ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.creationErrorString ? 22 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GCheckbox, i1.GChip, i1.GError, i1.GInput, IconComponent, ReactiveFormsModule, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName],
        styles: [".delete-pill[_ngcontent-%COMP%]{width:.75rem;height:.75rem;cursor:pointer}form[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:1rem}label[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:700;font-size:.875rem;width:fit-content}.buttons[_ngcontent-%COMP%]{align-self:flex-end;display:flex;justify-content:space-between;gap:.5rem}.buttons[_ngcontent-%COMP%] > .cancel-button[_ngcontent-%COMP%]{display:flex;padding:.5rem;text-decoration:underline;margin-bottom:1rem;cursor:pointer}.error[_ngcontent-%COMP%]{color:#920000;text-align:center;width:100%}.input[_ngcontent-%COMP%]{display:flex;flex-direction:column}.input[_ngcontent-%COMP%] > .domains-list[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);display:flex;flex-direction:row;align-items:center;gap:.5rem;padding:.8rem}.input[_ngcontent-%COMP%] > .domains-list[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{all:unset;flex-grow:1;font-size:.875rem}.input[_ngcontent-%COMP%] > .domains-list.focus[_ngcontent-%COMP%]{border:1px solid #000}.input[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]{align-self:last baseline;color:#737373;font-size:.6875rem;font-weight:400;margin-top:.25rem}.required[_ngcontent-%COMP%]{color:#920000}"]
      });
    }
  }
  return CreateOrganizationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * service to track the selected organization for use in the whole orgs and roles flow
 */
let SelectedOrgService = /*#__PURE__*/(() => {
  class SelectedOrgService {
    constructor() {
      this.organizationReadOnlyControllerService = inject(OrganizationReadOnlyControllerService);
      /** The currently selected organization. `null` if none selected. */
      this.org = signal(null);
    }
    /**
     * Selects the organization for the given UUID (or clears it out if NULL).
     *
     * @example
     * ```
     * inject(SelectedOrgService).selectOrg(uuid)
     *   .subscribe({
     *      next: (didSelect) => {
     *        if (didSelect) {
     *          // `uuid` was selected and data was fetched
     *        } else {
     *          // we deselected an organization (`uuid` was null)
     *        }
     *      },
     *      error: (err) => {
     *        // we couldn't fetch the org data
     *      }
     *  });
     * ```
     *
     * @returns `true` if an organization was selected, and `false` if the selection
     * was cleared out purposefully (i.e., we do not have an organization selected).
     */
    selectOrg(uuid) {
      if (uuid === this.org()?.uuid) return of(true); // we already have it
      // we're selecting a new org so we always start fresh
      this.org.set(null);
      return uuid == null ? of(false) : this.organizationReadOnlyControllerService.getOrganization(uuid).pipe(switchMap(org => {
        this.org.set(org);
        return of(true);
      }));
    }
    static {
      this.ɵfac = function SelectedOrgService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectedOrgService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SelectedOrgService,
        factory: SelectedOrgService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SelectedOrgService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MEMBER_ROLE_TYPE_ID = 2;
const MEMBER_ROLE = {
  uuid: '4735db29-5dd8-476a-b962-8851d71f540d',
  name: 'Organization Member'
};
const OWNER_ROLE = {
  uuid: '7a93f618-7b27-4385-908e-081ac77f7fc3',
  name: 'Organization Owner'
};

/**
 * This service provides an API to get the possible roles and role functions from backend
 *
 * Other services and components can use this data to gather role names, descriptions, etc.
 */
let RolesService = /*#__PURE__*/(() => {
  class RolesService {
    constructor() {
      this.roles = signal([]);
      this.roleCreatedSubject = new Subject();
      this.roleUpdatedSubject = new Subject();
      this.roleDeletedSubject = new Subject();
      this.roleCreated$ = this.roleCreatedSubject.asObservable();
      this.roleUpdated$ = this.roleUpdatedSubject.asObservable();
      this.roleDeleted$ = this.roleDeletedSubject.asObservable();
      this.selectedOrgService = inject(SelectedOrgService);
      this.roleReadControllerService = inject(RoleReadOnlyControllerService);
      this.roleWriteControllerService = inject(RoleWriteControllerService);
      this.initialized = false;
      this.loadRoles().pipe(takeUntilDestroyed()).subscribe({
        error: () => console.error('Unable to load roles')
      });
    }
    ngOnDestroy() {
      this.roleCreatedSubject.complete();
      this.roleUpdatedSubject.complete();
      this.roleDeletedSubject.complete();
    }
    isInitialized() {
      return this.initialized;
    }
    /**
     * get an array of roles from their roleIds
     * @param ids The roleIds of the roles
     * @returns an array of roles
     */
    rolesByIds(ids) {
      return this.roles().filter(role => ids.includes(role.uuid ?? ''));
    }
    roleNameById(id) {
      const role = this.roles().find(r => r.uuid === id);
      return role?.name ?? '';
    }
    loadRoles() {
      this.roles.set([]);
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.roleReadControllerService.getRoles(MEMBER_ROLE_TYPE_ID, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(switchMap(roles => {
        roles.sort((a, b) => a.name.localeCompare(b.name));
        this.roles.set(roles);
        this.initialized = true;
        return EMPTY;
      }));
    }
    /**
     * Create role - restricted to custom roles (not garminDefined)
     * @param role - the role to create
     * @returns the created role
     */
    createCustomRole(role) {
      if (role.garminDefined === true) return throwError(() => 'Authorization error: cannot perform the create operation for a Garmin defined role.');
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.roleWriteControllerService.createRole(role, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(tap(createdRole => {
        this.roles.update(roles => [...roles, createdRole]);
        this.roleCreatedSubject.next();
      }));
    }
    /**
     * Update role - restricted to custom roles (not garminDefined)
     * @param role - the role to update
     * @returns the updated role
     */
    updateCustomRole(roleToUpdate) {
      if (roleToUpdate.uuid == null) return throwError(() => 'The uuid of the provided role is required.');
      if (roleToUpdate.garminDefined === true) return throwError(() => 'Authorization error: cannot perform the update operation for a Garmin defined role.');
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.roleWriteControllerService.updateRole(roleToUpdate.uuid, roleToUpdate, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(tap(updatedRole => {
        this.roles.update(roles => roles.map(role => role.uuid === roleToUpdate.uuid ? updatedRole : role));
        this.roleUpdatedSubject.next();
      }));
    }
    /**
     * Update role permissions - restricted to custom roles (not garminDefined)
     * @param uuid - uuid of the role to update permissions for
     * @param permissionIds - the list of permission ids to update to
     * @returns the list of updated permissions
     */
    updateCustomRolePermissions(uuid, permissionIds) {
      const roleToUpdate = this.roles().find(role => role.uuid === uuid);
      if (roleToUpdate == null) return throwError(() => 'No role found.');
      if (roleToUpdate.garminDefined === true) return throwError(() => 'Authorization error: cannot perform the update permissions operation on a Garmin defined role.');
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.roleWriteControllerService.updateRolePermissions(uuid, permissionIds, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(tap(() => {
        this.roleUpdatedSubject.next();
      }));
    }
    /**
     * Delete role - restricted to custom roles (not garminDefined)
     * @param uuid The UUID of the role
     */
    deleteCustomRole(uuid) {
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      const roleToRemove = this.roles().find(role => role.uuid === uuid);
      if (roleToRemove == null) return throwError(() => 'No role found.');
      if (roleToRemove.garminDefined === true) return throwError(() => 'Authorization error: cannot perform the delete operation on a Garmin defined role.');
      return this.roleWriteControllerService.deleteRole(uuid, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(switchMap(() => {
        this.roles.update(role => role.filter(m => m.uuid !== uuid));
        this.roleDeletedSubject.next(uuid);
        return EMPTY;
      }));
    }
    static {
      this.ɵfac = function RolesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RolesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RolesService,
        factory: RolesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RolesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleSummariesService = /*#__PURE__*/(() => {
  class RoleSummariesService {
    constructor() {
      this.roleSummaries = signal([]);
      this.customRoleSummaries = computed(() => this.roleSummaries().filter(role => role.garminDefined === false));
      this.selectedOrgService = inject(SelectedOrgService);
      this.roleReadControllerService = inject(RoleReadOnlyControllerService);
      this.rolesService = inject(RolesService);
      this.initialized = false;
      this.load().pipe(takeUntilDestroyed()).subscribe({
        error: () => console.error('Unable to load summaries')
      });
      this.rolesService.roleDeleted$.pipe(takeUntilDestroyed()).subscribe(roleDeletedUuid => {
        this.roleSummaries.update(roleSummaries => roleSummaries.filter(roleSummary => roleSummary.uuid !== roleDeletedUuid));
      });
      merge(this.rolesService.roleCreated$, this.rolesService.roleUpdated$).pipe(switchMap(() => this.load()), takeUntilDestroyed()).subscribe();
    }
    isInitialized() {
      return this.initialized;
    }
    load() {
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.roleReadControllerService.getRoleSummaries(MEMBER_ROLE_TYPE_ID, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(switchMap(roleSummaries => {
        this.roleSummaries.set(roleSummaries);
        this.initialized = true;
        return EMPTY;
      }), catchError(error => {
        this.roleSummaries.set([]);
        return throwError(() => error);
      }));
    }
    getRoleById(id, considerGarminDefinedRoles = true) {
      return this.roleSummaries().find(roleSummary => {
        return (considerGarminDefinedRoles || roleSummary.garminDefined === false) && roleSummary.uuid === id;
      }) ?? null;
    }
    static {
      this.ɵfac = function RoleSummariesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleSummariesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RoleSummariesService,
        factory: RoleSummariesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RoleSummariesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var OrgsStorageKey = /*#__PURE__*/function (OrgsStorageKey) {
  OrgsStorageKey["ORGANIZATION_UUID"] = "ORGANIZATION-UUID";
  return OrgsStorageKey;
}(OrgsStorageKey || {});
let OrganizationsService = /*#__PURE__*/(() => {
  class OrganizationsService {
    get activeOrganization() {
      return this._activeOrganization;
    }
    get organizations() {
      return this._organizations;
    }
    constructor() {
      this.garminGlobalStoreService = inject(GarminGlobalStoreService);
      this.inactiveOrganizations = computed(() => {
        return this.organizations().filter(org => org.uuid !== this.activeOrganization()?.uuid);
      });
      this.orgsReadService = inject(OrganizationReadOnlyControllerService);
      this.orgsWriteService = inject(OrganizationWriteControllerService);
      this.customerReadService = inject(CustomerReadOnlyControllerService);
      this.localStorageService = inject(LocalStorageService);
      this.cookieService = inject(CookieService);
      this.destroyRef = inject(DestroyRef);
      this._organizations = signal([]);
      this._activeOrganization = signal(null);
      this.load();
    }
    load() {
      if (this.loadOrganizationState !== 'LOADING' && this.localStorageService.get(LocalStorageKey.OAuthTokenResponse)?.customerId != null) {
        this.loadOrganizationState = 'LOADING';
        this.orgsReadService.getOrganizations().pipe(switchMap(orgs => {
          this._organizations.set(orgs);
          const uuid = this.cookieService.get(OrgsStorageKey.ORGANIZATION_UUID) ?? this.garminGlobalStoreService.getGlobal('org.uuid');
          return uuid != null ? this.orgsReadService.getOrganizationSummary(uuid) : of();
        }), takeUntilDestroyed(this.destroyRef), catchError(error => {
          console.error(`An error ocurred loading organizations \n`, error.error);
          this.loadOrganizationState = 'ERROR';
          return throwError(() => new Error('Unable to load organizations'));
        })).subscribe(orgSummary => {
          if (orgSummary != null) {
            this.setOrganization(orgSummary);
          }
          this.loadOrganizationState = 'LOADED';
        });
      }
    }
    create(org, ownerEmail, allowedEmailDomains) {
      return this.customerReadService.searchGarminCustomersPost({
        email: ownerEmail
      }).pipe(switchMap(customerAccounts => {
        if (customerAccounts.length > 0) {
          return this.orgsWriteService.createOrganizationWithOwnership({
            ...org,
            // Emails are unique so only 1 account should come back
            ownerCustomerGuid: customerAccounts[0].id,
            allowedEmailDomains
          });
        } else {
          return throwError(() => new Error(`Customer with email: ${ownerEmail}, does not exist`));
        }
      })).pipe(switchMap(createdOrg => {
        this._organizations.update(prev => prev.concat(createdOrg));
        return of(createdOrg);
      }), takeUntilDestroyed(this.destroyRef), catchError(error => {
        console.error(`An error occurred creating org: ${org.name} \n`, error.error);
        return throwError(() => new Error('Unable to create organization'));
      }));
    }
    /**
     * get an array of organizations from their organizationIds
     * @param ids The organizationIds of the organizations
     * @returns an array of organizations
     */
    organizationsByIds(ids) {
      return this._organizations().filter(org => ids.includes(org.uuid ?? ''));
    }
    switchOrg(uuid) {
      if (uuid != null) {
        this.orgsReadService.getOrganizationSummary(uuid).pipe(takeUntilDestroyed(this.destroyRef), catchError(error => {
          console.error(`An error ocurred loading organizations \n`, error.error);
          return throwError(() => new Error('Unable to load organizations'));
        })).subscribe(orgSummary => {
          this.setOrganization(orgSummary);
        });
      } else {
        this._activeOrganization.set(null);
      }
    }
    setOrganization(orgSummary) {
      this._activeOrganization.set(orgSummary);
      if (orgSummary?.uuid != null) {
        this.cookieService.set(OrgsStorageKey.ORGANIZATION_UUID, orgSummary.uuid);
      } else {
        this.cookieService.delete(OrgsStorageKey.ORGANIZATION_UUID);
      }
    }
    static {
      this.ɵfac = function OrganizationsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrganizationsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OrganizationsService,
        factory: OrganizationsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OrganizationsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

//TODO: Remove dummy data
const USER_MEMBERSHIPS = [{
  organizationUuid: '9ad57fa6-e955-491e-a1f1-dc649c9ede0b',
  roleUuid: 'ce1bbef7-7539-4379-a886-8f2dec2a9e0d'
}, {
  organizationUuid: '5403b6d8-d8a0-4f8e-a31b-752afb523109',
  roleUuid: '0b1617e2-1bed-42b1-a15d-e41d478fa328'
}, {
  organizationUuid: '5403b6d8-d8a0-4f8e-a31b-752afb523109',
  roleUuid: '7a93f618-7b27-4385-908e-081ac77f7fc3'
}];
/**
 * This service provides an API to get the role -><- organization memberships for the currently signed-in user from backend
 *
 * Other services and components can use this data to display/make decisions based on a user's roles on an organization or
 * organizations the user is a part of which have a certain role
 */
let UserMembershipsService = /*#__PURE__*/(() => {
  class UserMembershipsService {
    constructor() {
      //TODO: fetch from backend
      this.userMemberships = signal(USER_MEMBERSHIPS);
    }
    loadUserMemberships() {
      //TODO: fetch from backend
      this.userMemberships.set(USER_MEMBERSHIPS);
    }
    /**
     * Get roleIds of the current user by organizationId
     * @param id organizationId
     * @returns an array of roleIds
     */
    roleIdsByOrganizationId(id) {
      return this.userMemberships().filter(membership => membership.organizationUuid === id).map(membership => membership.roleUuid);
    }
    static {
      this.ɵfac = function UserMembershipsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserMembershipsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserMembershipsService,
        factory: UserMembershipsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UserMembershipsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * pipe to get the user role to display for an organization based on ORG_ROLE_PRIORITY
 */
let UserRoleByOrgIdPipe = /*#__PURE__*/(() => {
  class UserRoleByOrgIdPipe {
    constructor() {
      this.ORGANIZATION_FUNCTION_ID = 0;
      this.ORG_ROLE_PRIORITY = ['Administrator', 'Owner'];
      this.rolesService = inject(RolesService);
      this.userMembershipsService = inject(UserMembershipsService);
    }
    transform(orgId) {
      if (orgId == null) return 'Personal Account';
      const roles = this.rolesService.rolesByIds(this.userMembershipsService.roleIdsByOrganizationId(orgId)).filter(role => role.functionId === this.ORGANIZATION_FUNCTION_ID);
      const rolesDisplay = roles.map(role => role.name?.replace('Organization', '').trim());
      for (const priorityRole of this.ORG_ROLE_PRIORITY) {
        if (rolesDisplay.includes(priorityRole)) return priorityRole;
      }
      return '';
    }
    static {
      this.ɵfac = function UserRoleByOrgIdPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserRoleByOrgIdPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyUserRoleByOrgId",
        type: UserRoleByOrgIdPipe,
        pure: true
      });
    }
  }
  return UserRoleByOrgIdPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrgsSelectorComponent = /*#__PURE__*/(() => {
  class OrgsSelectorComponent {
    constructor() {
      this.viewAccountInfo = new EventEmitter();
      this.signOut = new EventEmitter();
      this.organizationService = inject(OrganizationsService);
      this.userMembershipService = inject(UserMembershipsService);
      this.rolesService = inject(RolesService);
    }
    onClickViewAccountInfo() {
      this.viewAccountInfo.emit();
    }
    onClickSignOut() {
      this.signOut.emit();
    }
    onClickSwitchOrgButton(orgId) {
      this.organizationService.switchOrg(orgId);
    }
    static {
      this.ɵfac = function OrgsSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgsSelectorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrgsSelectorComponent,
        selectors: [["fly-orgs-selector"]],
        outputs: {
          viewAccountInfo: "viewAccountInfo",
          signOut: "signOut"
        },
        decls: 26,
        vars: 5,
        consts: [[1, "orgs-selector-container"], [1, "heading"], [1, "current-context"], [1, "title"], [1, "role"], [1, "buttons"], [3, "click"], [1, "body"], [1, "other-contexts"], [1, "grouping"], [1, "contexts"], [1, "context"], [1, "context", 3, "click"]],
        template: function OrgsSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "header")(2, "p", 1);
            i0.ɵɵtext(3, "YOUR ACCOUNTS");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2)(5, "p", 3);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "p", 4);
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "flyUserRoleByOrgId");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 5)(11, "button", 6);
            i0.ɵɵlistener("click", function OrgsSelectorComponent_Template_button_click_11_listener() {
              return ctx.onClickViewAccountInfo();
            });
            i0.ɵɵtext(12, "View Account Info");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "button", 6);
            i0.ɵɵlistener("click", function OrgsSelectorComponent_Template_button_click_13_listener() {
              return ctx.onClickSignOut();
            });
            i0.ɵɵtext(14, "Sign Out");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 7)(16, "div", 1);
            i0.ɵɵtext(17, "Other Accounts");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div", 8)(19, "div", 9)(20, "p", 1);
            i0.ɵɵtext(21, "ORGANIZATIONS");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "div", 10);
            i0.ɵɵrepeaterCreate(23, OrgsSelectorComponent_For_24_Template, 4, 2, "button", 11, _forTrack0);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(25, OrgsSelectorComponent_Conditional_25_Template, 7, 0, "div", 9);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            let tmp_0_0;
            let tmp_1_0;
            let tmp_3_0;
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate((tmp_0_0 = ctx.organizationService.activeOrganization()) == null ? null : tmp_0_0.name);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 3, (tmp_1_0 = ctx.organizationService.activeOrganization()) == null ? null : tmp_1_0.uuid));
            i0.ɵɵadvance(15);
            i0.ɵɵrepeater(ctx.organizationService.inactiveOrganizations());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(((tmp_3_0 = ctx.organizationService.activeOrganization()) == null ? null : tmp_3_0.uuid) != null ? 25 : -1);
          }
        },
        dependencies: [CommonModule, UserRoleByOrgIdPipe],
        styles: [".orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .heading[_ngcontent-%COMP%]{font-size:1rem}}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%]{display:flex;flex-direction:column;background:#fafafa;padding:.75rem;gap:1rem;border-bottom:1px solid rgb(216.75,216.75,216.75)}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .heading[_ngcontent-%COMP%]{margin:0}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .current-context[_ngcontent-%COMP%] > .title[_ngcontent-%COMP%]{font-size:1.125rem;font-weight:700;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .current-context[_ngcontent-%COMP%] > .role[_ngcontent-%COMP%]{font-size:.875rem;font-style:italic;color:#737373}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .buttons[_ngcontent-%COMP%]{display:flex;justify-content:space-between;font-size:.75rem;flex-wrap:wrap}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .buttons[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{cursor:pointer}.orgs-selector-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .buttons[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:hover{text-decoration:underline}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%]{margin-bottom:1rem}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .heading[_ngcontent-%COMP%]{font-size:1rem;font-weight:700;padding:.75rem}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:1.25rem}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.25rem}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .heading[_ngcontent-%COMP%]{padding:0 .875rem;color:#6c6c6c;font-size:.75rem;font-weight:300;letter-spacing:1.08px;text-transform:uppercase}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .contexts[_ngcontent-%COMP%]{display:flex;flex-direction:column}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .contexts[_ngcontent-%COMP%] > .context[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:.25rem .875rem;border-top:1px solid #eee;cursor:pointer;flex-wrap:wrap}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .contexts[_ngcontent-%COMP%] > .context[_ngcontent-%COMP%]:hover{background:#fafafa}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .contexts[_ngcontent-%COMP%] > .context[_ngcontent-%COMP%] > .title[_ngcontent-%COMP%]{font-weight:700;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:100%;font-size:.75rem}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .contexts[_ngcontent-%COMP%] > .context[_ngcontent-%COMP%] > .role[_ngcontent-%COMP%]{font-size:.75rem;font-style:italic;color:#737373}.orgs-selector-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > .other-contexts[_ngcontent-%COMP%] > .grouping[_ngcontent-%COMP%] > .contexts[_ngcontent-%COMP%] > .context[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #eee}"]
      });
    }
  }
  return OrgsSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// a subset of `emailRegEx`
const EMAIL_DOMAIN_REGEX = /^@?[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const emailValidator = control => {
  return control.value == null || control.value === '' || EMAIL_DOMAIN_REGEX.test(control.value) ? null : {
    email: true
  };
};
let BasicOrgSettingsComponent = /*#__PURE__*/(() => {
  class BasicOrgSettingsComponent {
    constructor() {
      this.domainInput = new FormControl(null, {
        validators: [emailValidator]
      });
    }
    addDomain() {
      if (this.domainInput.errors != null) return;
      const domain = this.domainInput.value?.trim();
      if (domain == null || domain === '') return;
      if (this.domains().find(d => d === domain) == null) {
        this.domains.update(prev => [...prev, domain]);
      }
      this.domainInput.reset();
    }
    deleteDomain(domain) {
      this.domains.update(prev => prev.filter(d => d !== domain));
    }
    onClickStatusBanner() {
      this.status.set(null);
    }
    static {
      this.ɵfac = function BasicOrgSettingsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BasicOrgSettingsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BasicOrgSettingsComponent,
        selectors: [["fly-basic-org-settings"]],
        inputs: {
          domains: "domains",
          domainPreference: "domainPreference",
          status: "status"
        },
        decls: 12,
        vars: 6,
        consts: [[3, "closeable", "type"], [1, "desc"], ["label", "Anyone"], ["name", "domains", "type", "radio", 3, "formControl", "value"], ["label", "Only those with the below email domains"], [3, "click", "closeable", "type"], [1, "domain"], ["label", "Add Email Domain", "labelFor", "email-domain", 3, "error"], ["id", "email-domain", "placeholder", "@example.com or example.com", 3, "keydown.enter", "formControl"], [1, "subtext"], ["aria-label", "delete-domain", 3, "click"], ["icon", "trash-can", 1, "icon", "size-small", "color-red"]],
        template: function BasicOrgSettingsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BasicOrgSettingsComponent_Conditional_0_Template, 2, 3, "g-alert", 0);
            i0.ɵɵelementStart(1, "h2");
            i0.ɵɵtext(2, "ORGANIZATION SETTINGS");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p", 1);
            i0.ɵɵtext(4, "Here you can manage all of your organization's settings and preferences.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "h3");
            i0.ɵɵtext(6, "ACCOUNT DOMAIN PREFERENCES");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "g-radio", 2);
            i0.ɵɵelement(8, "input", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "g-radio", 4);
            i0.ɵɵelement(10, "input", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, BasicOrgSettingsComponent_Conditional_11_Template, 9, 3, "section");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.status() != null ? 0 : -1);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("formControl", ctx.domainPreference)("value", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formControl", ctx.domainPreference)("value", true);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.domainPreference.value ? 11 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GAlert, i1.GError, i1.GInput, i1.GRadio, IconComponent, ReactiveFormsModule, i2.DefaultValueAccessor, i2.RadioControlValueAccessor, i2.NgControlStatus, i2.FormControlDirective],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:flex;flex-direction:column;-webkit-user-select:none;user-select:none}.desc[_ngcontent-%COMP%]{padding-left:1rem;padding-bottom:3rem}g-radio[_ngcontent-%COMP%]{padding-left:1rem;cursor:pointer;width:fit-content}section[_ngcontent-%COMP%]{margin-left:2.5rem;max-width:25rem}.domain[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding:.5rem;border-bottom:1px solid #999999}.domain[_ngcontent-%COMP%]:last-child{border-bottom:none}.domain[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{cursor:pointer}g-input[_ngcontent-%COMP%]{margin-top:1rem}.subtext[_ngcontent-%COMP%]{float:right;font-size:.6875rem;margin-top:.35rem}"]
      });
    }
  }
  return BasicOrgSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ORG_ACCESS_CONTROLS_TOKEN = new InjectionToken('ORG_ACCESS_CONTROLS_TOKEN');

/**
 * This service provides an API to get the permissions
 *
 * Other services and components can use this data to gather permission
 */
let PermissionsService = /*#__PURE__*/(() => {
  class PermissionsService {
    constructor() {
      this.permissions = signal([]);
      this.selectedOrgService = inject(SelectedOrgService);
      this.permissionReadOnlyControllerService = inject(PermissionReadOnlyControllerService);
      this.load().pipe(takeUntilDestroyed()).subscribe({
        error: () => console.error('Unable to load permissions')
      });
    }
    load() {
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.permissionReadOnlyControllerService.getPermissions(false, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(switchMap(permissions => {
        this.permissions.set([...permissions].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')));
        return EMPTY;
      }), catchError(error => {
        this.permissions.set([]);
        return throwError(() => error);
      }));
    }
    static {
      this.ɵfac = function PermissionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PermissionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PermissionsService,
        factory: PermissionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PermissionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This service is responsible for computing the set of roles that are
 * actually displayed in the Roles table with sorting, filtering, and pagination
 * applied.
 */
let RolesTableService = /*#__PURE__*/(() => {
  class RolesTableService {
    sortRoles(col, value) {
      if (col === 'role') {
        if (value != null) {
          this.sortDirRole.set(value);
        } else {
          this.sortDirRole.update(prev => prev === 0 ? 1 : prev * -1);
        }
        this.sortBySelection.setValue(this.sortDirRole() === 1 ? 'Role - ASC' : 'Role - DESC', {
          emitEvent: false
        });
        this.sortDirDescription.set(0);
      }
      if (col === 'description') {
        if (value != null) {
          this.sortDirDescription.set(value);
        } else {
          this.sortDirDescription.update(prev => prev === 0 ? 1 : prev * -1);
        }
        this.sortBySelection.setValue(this.sortDirDescription() === 1 ? 'Description - ASC' : 'Description - DESC', {
          emitEvent: false
        });
        this.sortDirRole.set(0);
      }
    }
    constructor() {
      this.roleSummariesService = inject(RoleSummariesService);
      this.searchInput = new FormControl(null);
      this.searchText = toSignal(this.searchInput.valueChanges, {
        initialValue: null
      });
      this.permissionSelection = new FormControl(null);
      this.permissionId = toSignal(this.permissionSelection.valueChanges, {
        initialValue: null
      });
      this.sortDirRole = signal(1);
      this.sortDirDescription = signal(0);
      // this is for small screens only since we only have one column in this case
      this.sortBySelection = new FormControl('Role - ASC', {
        nonNullable: true
      });
      this.ROW_LIMIT = 5;
      this.currentPage = signal(1);
      this.totalPages = computed(() => Math.ceil(this.filteredRoles().length / this.ROW_LIMIT));
      this.showAll = signal(false);
      this.filteredRoles = computed(() => {
        let roles = this.roleSummariesService.customRoleSummaries();
        const search = this.searchText()?.toLowerCase();
        const permissionId = this.permissionId();
        if (search != null) {
          roles = roles.filter(m => m.name.toLowerCase().includes(search));
        }
        if (permissionId != null) {
          roles = roles.filter(role => role.permissions?.some(permission => permission.id === permissionId));
        }
        roles = [...roles].sort((a, b) => {
          const roleSort = a.name.localeCompare(b.name) * this.sortDirRole();
          if (roleSort !== 0) return roleSort;
          const descriptionSort = a.description.localeCompare(b.description) * this.sortDirDescription();
          return descriptionSort;
        });
        return roles;
      });
      // The set of roles on the current page
      this.currentPageRoles = computed(() => {
        const roles = this.filteredRoles();
        if (this.showAll()) return roles;
        // `currentPage` starts from 1 but we need to use it here to slice an array (which starts from 0)
        const start = (this.currentPage() - 1) * this.ROW_LIMIT;
        return roles.slice(start, start + this.ROW_LIMIT);
      });
      // any time `filteredRoles` is recomputed, we want to reset `currentPage`
      effect(() => {
        this.filteredRoles();
        untracked(() => this.currentPage.set(1));
      });
      this.sortBySelection.valueChanges.pipe(takeUntilDestroyed()).subscribe(value => {
        switch (value) {
          case 'Role - ASC':
            this.sortRoles('role', 1);
            break;
          case 'Role - DESC':
            this.sortRoles('role', -1);
            break;
          case 'Description - ASC':
            this.sortRoles('description', 1);
            break;
          case 'Description - DESC':
            this.sortRoles('description', -1);
            break;
          default:
            break;
        }
      });
    }
    static {
      this.ɵfac = function RolesTableService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RolesTableService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RolesTableService,
        factory: RolesTableService.ɵfac
      });
    }
  }
  return RolesTableService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageControlsComponent = /*#__PURE__*/(() => {
  class PageControlsComponent {
    pageChanged(event) {
      this.currentPage.set(event.detail);
    }
    static {
      this.ɵfac = function PageControlsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PageControlsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PageControlsComponent,
        selectors: [["fly-page-controls"]],
        inputs: {
          label: "label",
          count: "count",
          total: "total",
          totalPages: "totalPages",
          currentPage: "currentPage",
          showAll: "showAll"
        },
        decls: 5,
        vars: 5,
        consts: [[1, "counts"], ["size", "small"], [3, "currentPage", "totalPages"], ["size", "small", 3, "click"], [3, "g-page-changed", "currentPage", "totalPages"]],
        template: function PageControlsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, PageControlsComponent_Conditional_3_Template, 2, 1, "g-button", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, PageControlsComponent_Conditional_4_Template, 1, 2, "g-pagination", 2);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate3("Showing ", ctx.count, " of ", ctx.total, " ", ctx.label, "");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.totalPages > 1 ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.showAll() && ctx.totalPages > 1 ? 4 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GPagination],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column-reverse;justify-content:center;gap:1rem;align-items:center}@media screen and (min-width: 768px){[_nghost-%COMP%]{flex-direction:row;justify-content:space-between}}.counts[_ngcontent-%COMP%]{display:flex;gap:1rem;align-items:center;font-weight:500;font-size:.75rem}.counts[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{flex-shrink:0}"]
      });
    }
  }
  return PageControlsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PermissionCellComponent = /*#__PURE__*/(() => {
  class PermissionCellComponent {
    constructor() {
      this.otherPermissions = [];
    }
    ngOnInit() {
      if (this.roleSummary.permissions != null && this.roleSummary.permissions.length > 0) {
        this.displayedPermission = this.roleSummary.permissions[0];
        this.otherPermissions = this.roleSummary.permissions.filter(permission => permission.id !== this.displayedPermission.id);
      }
    }
    static {
      this.ɵfac = function PermissionCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PermissionCellComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PermissionCellComponent,
        selectors: [["fly-permission-cell"]],
        inputs: {
          roleSummary: "roleSummary"
        },
        decls: 2,
        vars: 1,
        consts: [["heading", ""], [1, "g-collapsible-region", 3, "expanded"], [1, "permission"], [1, "more"], [4, "ngTemplateOutlet"], ["slot", "heading", 1, "text"], ["slot", "body"]],
        template: function PermissionCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PermissionCellComponent_Conditional_0_Template, 2, 0, "span")(1, PermissionCellComponent_Conditional_1_Template, 4, 1);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional(((tmp_0_0 = ctx.roleSummary.permissions == null ? null : ctx.roleSummary.permissions.length) !== null && tmp_0_0 !== undefined ? tmp_0_0 : 0) === 0 ? 0 : 1);
          }
        },
        dependencies: [CommonModule, i1$1.NgTemplateOutlet, ComponentsGlobalWebModule, i1.GCollapsibleRegion],
        styles: [".ellipsis[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}[_nghost-%COMP%]{-webkit-user-select:none;user-select:none}.permission[_ngcontent-%COMP%]{max-width:14rem}.more[_ngcontent-%COMP%]{font-size:.875rem}a[_ngcontent-%COMP%]{font-size:.875rem;display:block}.g-collapsible-region[_ngcontent-%COMP%]{margin:unset}.text[_ngcontent-%COMP%]{display:flex;gap:.5rem;align-items:center}.text[_ngcontent-%COMP%] > .permission[_ngcontent-%COMP%]{flex:1 1 auto}.text[_ngcontent-%COMP%] > .more[_ngcontent-%COMP%]{flex:0 0 auto}"]
      });
    }
  }
  return PermissionCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RolesTableComponent = /*#__PURE__*/(() => {
  class RolesTableComponent {
    constructor() {
      this.activatedRoute = inject(ActivatedRoute);
      this.roleSummariesService = inject(RoleSummariesService);
      this.rolesService = inject(RolesService);
      this.router = inject(Router);
      this.rolesTableService = inject(RolesTableService);
      this.permissionsService = inject(PermissionsService);
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
      this.libConfig = inject(FLY_WEB_COMMON_CONFIG);
      this.sortByOptions = ['Role - ASC', 'Role - DESC', 'Description - ASC', 'Description - DESC'];
      this.roleRemoveState = signal('UNSET');
      this.state = signal('LOADING');
      this.roleToRemove = null;
      this.destroyRef = inject(DestroyRef);
      this.onConfirmRemoval = () => {
        this.roleRemoveState.set('LOADING');
        if (this.roleToRemove == null) {
          console.error('No role found to remove.');
          this.roleRemoveState.set('ERROR');
        } else {
          this.rolesService.deleteCustomRole(this.roleToRemove.uuid).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            complete: () => {
              this.roleRemoveState.set('LOADED');
              this.modal.close();
            },
            error: () => this.roleRemoveState.set('ERROR')
          });
        }
      };
      this.onCloseRemoveModal = () => {
        this.modal.close();
        // The focus state of the 'Remove' button persists even after closing the modal. Manually remove the focus.
        this.buttons.forEach(button => button.removeFocus());
      };
    }
    ngOnInit() {
      if (this.roleSummariesService.isInitialized()) {
        this.state.set('LOADED');
      } else {
        this.loadRoles();
      }
    }
    loadRoles() {
      this.state.set('LOADING');
      this.roleSummariesService.load().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => this.state.set('LOADED'),
        error: () => this.state.set('ERROR')
      });
    }
    navigateToEditRole(uuid) {
      this.router.navigate(['edit', uuid], {
        relativeTo: this.activatedRoute,
        state: {
          breadcrumbs: ['ROLES', 'UPDATE ROLE'],
          back: 'roles'
        }
      });
    }
    removeRole(roleSummary) {
      this.roleRemoveState.set('UNSET');
      this.roleToRemove = roleSummary;
      this.modal.open();
    }
    static {
      this.ɵfac = function RolesTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RolesTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RolesTableComponent,
        selectors: [["fly-roles-table"]],
        viewQuery: function RolesTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(GButton, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttons = _t);
          }
        },
        features: [i0.ɵɵProvidersFeature([RolesTableService])],
        decls: 9,
        vars: 15,
        consts: [["modal", ""], ["type", "dark", 1, "loader"], [1, "error"], [3, "header", "buttons", "showCloseBtn"], [1, "main-body"], [1, "remove-error-text"], [1, "grid"], [1, "row", "controls"], ["label", "Search by Role", 1, "search", 3, "inputControl"], ["label", "Filter by Permissions", 1, "filter"], ["name", "permission-select", 3, "formControl"], ["selected", "", 3, "ngValue"], [3, "ngValue"], ["label", "Sort By", 1, "sort-by"], ["name", "sort-by-select", 3, "formControl"], [3, "value"], [1, "row", "header"], ["colName", "Role", 1, "label", 3, "click", "sortDir"], ["colName", "Description", 1, "label", 3, "click", "sortDir"], [1, "label"], [1, "refresh-btn", 3, "click"], ["icon", "refresh-arrows", 1, "icon"], ["label", "Roles", 3, "count", "total", "currentPage", "totalPages", "showAll"], [1, "no-results"], [1, "row", "data"], [1, "ellipsis"], [3, "roleSummary"], [1, "control-buttons"], ["size", "small", "theme", "black", 3, "click"], [1, "control-button-text"], ["size", "small", 3, "click"], ["icon", "error", 1, "icon", "size-large", "color-red"], [1, "desc"], [1, "text"], ["theme", "black", 3, "click"], [1, "button-contents"], ["icon", "refresh-arrows", 1, "icon", "size-standard", "color-white"]],
        template: function RolesTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, RolesTableComponent_Conditional_0_Template, 23, 8)(1, RolesTableComponent_Conditional_1_Template, 1, 0, "g-loader", 1)(2, RolesTableComponent_Conditional_2_Template, 11, 0, "div", 2);
            i0.ɵɵelementStart(3, "fly-modal", 3, 0)(5, "span", 4);
            i0.ɵɵtext(6, " This role will be removed from all members previously assigned to this role. ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, RolesTableComponent_Case_7_Template, 2, 0, "p", 5)(8, RolesTableComponent_Case_8_Template, 2, 0, "span");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_7_0;
            i0.ɵɵconditional(ctx.state() !== "ERROR" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.state() === "LOADING" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.state() === "ERROR" ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("header", "Are you sure you want to remove ", ctx.roleToRemove == null ? null : ctx.roleToRemove.name, "?");
            i0.ɵɵproperty("buttons", i0.ɵɵpureFunction2(12, _c3, i0.ɵɵpureFunction1(8, _c1, ctx.onCloseRemoveModal), i0.ɵɵpureFunction1(10, _c2, ctx.onConfirmRemoval)))("showCloseBtn", false);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional((tmp_7_0 = ctx.roleRemoveState()) === "ERROR" ? 7 : tmp_7_0 === "LOADING" ? 8 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GDropDown, i1.GLoader, ModalComponent, FormsModule, i2.NgSelectOption, i2.ɵNgSelectMultipleOption, i2.SelectControlValueAccessor, i2.NgControlStatus, ReactiveFormsModule, i2.FormControlDirective, SortableColumnHeaderComponent, SearchInputComponent, PageControlsComponent, PermissionCellComponent, IconComponent],
        styles: [".refresh-btn[_ngcontent-%COMP%]{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}.header[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem}.ellipsis[_ngcontent-%COMP%], .filter[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:auto}.header[_ngcontent-%COMP%]{text-transform:uppercase;border-bottom:2px solid #000;-webkit-user-select:none;user-select:none}.header[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.header[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{display:flex;height:fit-content;padding:1rem}}.row[_ngcontent-%COMP%]{display:grid;grid-column:1/-1;grid-template-columns:auto;grid-template-rows:repeat(auto-fit,minmax(0,max-content));gap:.25rem;padding:1rem}@media screen and (min-width: 768px){.row[_ngcontent-%COMP%]{grid-template-columns:subgrid;grid-template-rows:subgrid;gap:0;padding:0}}.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:0}@media screen and (min-width: 768px){.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:1rem}}.single-item-row[_ngcontent-%COMP%]{grid-column:1/-1}.hidden[_ngcontent-%COMP%]{display:none}.data[_ngcontent-%COMP%]{border-bottom:1px solid rgb(216.75,216.75,216.75)}.control-buttons[_ngcontent-%COMP%]{justify-self:end;display:flex;flex-direction:column;justify-content:flex-end;gap:.5rem}.control-buttons[_ngcontent-%COMP%]   .control-button-text[_ngcontent-%COMP%]{display:inline-block;min-width:3rem}@media screen and (min-width: 768px){.control-buttons[_ngcontent-%COMP%]{flex-direction:row}.control-buttons[_ngcontent-%COMP%]   .control-button-text[_ngcontent-%COMP%]{min-width:0}}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}button[_ngcontent-%COMP%]{cursor:pointer}.no-results[_ngcontent-%COMP%]{margin-top:.5rem;color:#737373}.error[_ngcontent-%COMP%]{display:flex;border-top:3px solid #000;padding-top:1rem;margin-top:2rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-left:1rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%] > .text[_ngcontent-%COMP%]{margin-bottom:1.25rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%]   .button-contents[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%]   .button-contents[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{margin-right:.5rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%] > .loader[_ngcontent-%COMP%]{width:4rem}@media screen and (min-width: 768px){.grid[_ngcontent-%COMP%]{grid-template-columns:repeat(2,.7fr) minmax(12rem,1fr) max-content}}.refresh-btn[_ngcontent-%COMP%]{letter-spacing:.05rem;color:#106fad;width:fit-content;display:flex;gap:.25rem;align-items:center;justify-self:flex-end}.refresh-btn[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{fill:#106fad;width:1rem;height:1rem}@media screen and (min-width: 768px){.search[_ngcontent-%COMP%]{grid-column:1}}@media screen and (min-width: 768px){.filter[_ngcontent-%COMP%]{grid-column:3}}.sort-by[_ngcontent-%COMP%]{display:inline}@media screen and (min-width: 768px){.sort-by[_ngcontent-%COMP%]{display:none}}.remove-error-text[_ngcontent-%COMP%]{display:flex;color:#920000;margin-top:.5rem;justify-content:center}.loader[_ngcontent-%COMP%]{display:flex;margin:0 auto;width:5rem}.main-body[_ngcontent-%COMP%]{display:flex;font-weight:700;justify-content:center}"]
      });
    }
  }
  return RolesTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrgsCustomRolesComponent = /*#__PURE__*/(() => {
  class OrgsCustomRolesComponent {
    constructor() {
      this.router = inject(Router);
      this.activatedRoute = inject(ActivatedRoute);
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
    }
    navigateToCreateRole() {
      this.router.navigate(['create'], {
        relativeTo: this.activatedRoute,
        state: {
          breadcrumbs: ['ROLES', 'CREATE NEW ROLE'],
          back: 'roles'
        }
      });
    }
    static {
      this.ɵfac = function OrgsCustomRolesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgsCustomRolesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrgsCustomRolesComponent,
        selectors: [["ng-component"]],
        decls: 8,
        vars: 3,
        consts: [[1, "top-desc"], [1, "create-role-btn"], ["theme", "dark", 3, "click"]],
        template: function OrgsCustomRolesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "h2");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 0)(4, "p");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, OrgsCustomRolesComponent_Conditional_6_Template, 3, 0, "div", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "fly-roles-table");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", ctx.accessControls.canEditOrgRoles() ? "MANAGE" : "VIEW", " ROLES");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" Here you can ", ctx.accessControls.canEditOrgRoles() ? "access and manage" : "view", " all of the information about your organization\u2019s roles. ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.accessControls.canEditOrgRoles() ? 6 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, RolesTableComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}.top-desc[_ngcontent-%COMP%]{padding-left:1rem}.create-role-btn[_ngcontent-%COMP%]{margin:1.5rem 0}"]
      });
    }
  }
  return OrgsCustomRolesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var RoleWizardStep = /*#__PURE__*/function (RoleWizardStep) {
  RoleWizardStep[RoleWizardStep["Details"] = 0] = "Details";
  RoleWizardStep[RoleWizardStep["Permissions"] = 1] = "Permissions";
  RoleWizardStep[RoleWizardStep["Review"] = 2] = "Review";
  return RoleWizardStep;
}(RoleWizardStep || {});
var RoleWizardMode = /*#__PURE__*/function (RoleWizardMode) {
  RoleWizardMode[RoleWizardMode["CREATE"] = 0] = "CREATE";
  RoleWizardMode[RoleWizardMode["EDIT"] = 1] = "EDIT";
  return RoleWizardMode;
}(RoleWizardMode || {});
const EXCLUDE_ORG_CONTEXT_ID = new HttpContextToken(() => false);
/**
 * This service is responsible for creating organization specific context
 */
let OrgContextOptionsService = /*#__PURE__*/(() => {
  class OrgContextOptionsService {
    getExcludeOptions() {
      return {
        context: new HttpContext().set(EXCLUDE_ORG_CONTEXT_ID, true)
      };
    }
    static {
      this.ɵfac = function OrgContextOptionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgContextOptionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OrgContextOptionsService,
        factory: OrgContextOptionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OrgContextOptionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CONTEXT_ID_HEADER = 'X-garmin-context-uuid';
const GARMIN_CDN_HOST = 'static.garmincdn.com';
/**
 * This service is responsible for intercepting HTTP calls that require an Organization UUID
 * set as a context header
 */
let OrgContextInterceptorService = /*#__PURE__*/(() => {
  class OrgContextInterceptorService {
    constructor() {
      this.globalStorageService = inject(GarminGlobalStoreService);
    }
    intercept(req, next) {
      if (!req.context.get(EXCLUDE_ORG_CONTEXT_ID) && !req.url.includes(GARMIN_CDN_HOST)) {
        const organizationUuid = this.globalStorageService.getGlobal('org.uuid');
        if (organizationUuid !== undefined && organizationUuid !== '') {
          const headers = req.headers.set(CONTEXT_ID_HEADER, organizationUuid);
          return next.handle(req.clone({
            headers
          }));
        }
      }
      return next.handle(req);
    }
    static {
      this.ɵfac = function OrgContextInterceptorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgContextInterceptorService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OrgContextInterceptorService,
        factory: OrgContextInterceptorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OrgContextInterceptorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectedOrgFunctionsService = /*#__PURE__*/(() => {
  class SelectedOrgFunctionsService {
    constructor() {
      this.garminGlobalStorageService = inject(GarminGlobalStoreService);
      this.orgsReadService = inject(OrganizationReadOnlyControllerService);
      this.selectedOrgService = inject(SelectedOrgService);
      this.orgFunctions$ = null;
    }
    load(refresh) {
      if (refresh === true) this.orgFunctions$ = null;
      if (this.orgFunctions$ == null) {
        const orgUuid = this.selectedOrgService.org()?.uuid ?? this.garminGlobalStorageService.getGlobal('org.uuid');
        if (orgUuid == null) {
          return throwError(() => new Error('No org selected'));
        }
        this.orgFunctions$ = this.orgsReadService.getOrganizationFunctions(orgUuid).pipe(shareReplay(1), catchError(error => {
          console.error(`An error occurred loading organization functions \n`, error.error);
          return throwError(() => new Error('Unable to load organization functions'));
        }));
      }
      return this.orgFunctions$;
    }
    isFunctionEnabled(orgFunction) {
      const orgFunctions$ = this.orgFunctions$ ?? this.load();
      return orgFunctions$.pipe(map(functions => functions.some(func => func.id === orgFunction)));
    }
    static {
      this.ɵfac = function SelectedOrgFunctionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectedOrgFunctionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SelectedOrgFunctionsService,
        factory: SelectedOrgFunctionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SelectedOrgFunctionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This service provides an API for interacting with the members of an organization.
 */
let MembersService = /*#__PURE__*/(() => {
  class MembersService {
    constructor() {
      this.members = signal([]);
      this.membershipReadOnlyControllerService = inject(MembershipReadOnlyControllerService);
      this.membershipWriteControllerService = inject(MembershipWriteControllerService);
      this.authorizationReadOnlyControllerService = inject(AuthorizationReadOnlyControllerService);
      this.roleService = inject(RolesService);
      this.selectedOrgService = inject(SelectedOrgService);
      this.localStorageService = inject(LocalStorageService);
      this.garminGlobalStoreService = inject(GarminGlobalStoreService);
      this.router = inject(Router);
      this.initialized = false;
      merge(this.roleService.roleDeleted$, this.roleService.roleUpdated$).pipe(switchMap(() => this.loadMembers()), takeUntilDestroyed()).subscribe();
    }
    isInitialized() {
      return this.initialized;
    }
    toMembers(memberships) {
      const map = new Map();
      for (const membership of memberships) {
        if (membership.customerGuid == null || membership.roleSummary == null || membership.customerSummary == null) continue;
        const member = map.get(membership.customerGuid) ?? {
          customerGuid: membership.customerGuid,
          name: `${membership.customerSummary.firstName ?? ''} ${membership.customerSummary.lastName ?? ''}`,
          email: membership.customerSummary.primaryEmailAddress ?? '',
          isOwner: false,
          roles: []
        };
        const role = {
          uuid: membership.roleSummary.uuid ?? '',
          name: membership.roleSummary.name ?? '',
          membershipUuid: membership.uuid ?? ''
        };
        member.roles.push(role);
        member.isOwner = member.roles.find(r => r.name === 'Organization Owner') != null;
        if (!map.has(membership.customerGuid)) map.set(membership.customerGuid, member);
      }
      return Array.from(map.values());
    }
    loadMembers() {
      const uuid = this.selectedOrgService.org()?.uuid ?? this.garminGlobalStoreService.getGlobal('org.uuid');
      if (uuid == null) return throwError(() => new Error('no org selected'));
      return this.membershipReadOnlyControllerService.searchMemberships({
        organizationUuid: uuid
      }).pipe(switchMap(membershipArray => {
        this.members.set(this.toMembers(membershipArray));
        this.initialized = true;
        return EMPTY;
      }), catchError(error => {
        this.members.set([]);
        return throwError(() => error);
      }));
    }
    deleteMember(customerGuid) {
      const memberToRemove = this.members().find(m => m.customerGuid === customerGuid);
      if (memberToRemove == null) return EMPTY;
      const membershipIds = memberToRemove.roles.map(r => r.membershipUuid).filter(Boolean);
      return this.membershipWriteControllerService.deleteManyMemberships(membershipIds).pipe(switchMap(() => {
        this.members.update(members => members.filter(m => m.customerGuid !== customerGuid));
        // edge case: redirect to fly if the user just deleted themselves
        if (this.isMemberCurrentUser(customerGuid)) {
          this.garminGlobalStoreService.removeGlobal('org');
          this.router.navigate(['denied']);
        }
        return EMPTY;
      }));
    }
    updateRolesForMember(member, addedRoles, removedRoles) {
      const uuid = this.selectedOrgService.org()?.uuid;
      if (uuid == null) return throwError(() => new Error('no org selected'));
      const rolesToDelete = member.roles.filter(roleFromMember => removedRoles.some(role => role.uuid === roleFromMember.uuid));
      const requests = [forkJoin(rolesToDelete.map(r => this.membershipWriteControllerService.deleteMembership(r.membershipUuid))).pipe(defaultIfEmpty([])), forkJoin(addedRoles.map(role => this.membershipWriteControllerService.createMembership({
        customerGuid: member.customerGuid,
        organizationUuid: uuid,
        roleUuid: role.uuid ?? '',
        startDate: new Date().toISOString()
      }))).pipe(defaultIfEmpty([]))];
      return forkJoin(requests).pipe(
      // update the `members` array
      tap(([_, newMemberships]) => {
        this.members.update(members => {
          const nextMembers = [...members];
          if (rolesToDelete.length > 0) {
            member.roles = member.roles.filter(r => !rolesToDelete.some(rr => r.membershipUuid === rr.membershipUuid));
          }
          member.roles = [...member.roles, ...newMemberships.map(membership => ({
            uuid: membership.roleUuid,
            name: this.roleService.roleNameById(membership.roleUuid),
            membershipUuid: membership.uuid
          }))];
          const index = nextMembers.findIndex(m => m.customerGuid === member.customerGuid);
          nextMembers[index] = member;
          return nextMembers;
        });
      }),
      // edge case - member might have removed all of their roles with org-edit permission so check
      // if they're still allowed to be here
      switchMap(() => this.isMemberCurrentUser(member.customerGuid) ? this.authorizationReadOnlyControllerService.getContextAuthorization({
        customerGuid: member.customerGuid,
        permissionId: Permission.ORGANIZATION_EDIT
      }) : of(true)), switchMap(canStay => {
        if (!canStay) this.router.navigate(['denied']);
        return EMPTY;
      }));
    }
    getCurrentMember() {
      const customerId = this.localStorageService.get(LocalStorageKey.OAuthTokenResponse)?.customerId;
      return this.members().find(member => member.customerGuid === customerId) ?? null;
    }
    /**
     * This is for handling the following edge cases:
     * - The current user just deleted themselves from the organization.
     * - The current user just removed all of their own roles that gave them org-edit permission.
     *
     * @note This does not affect FALA because we do not store the admin LDAP token in local storage.
     */
    isMemberCurrentUser(customerGuid) {
      const customerId = this.localStorageService.get(LocalStorageKey.OAuthTokenResponse)?.customerId;
      return customerId != null && customerGuid === customerId;
    }
    static {
      this.ɵfac = function MembersService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembersService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MembersService,
        factory: MembersService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MembersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ORG_SETTINGS_SERVICE_TOKEN = new InjectionToken('ORG_SETTINGS_SERVICE_TOKEN');
class AbstractOrgSettingsService {
  constructor() {
    this.allowedEmailDomains = signal([]);
    this.useCustomDomainList = new FormControl(false, {
      nonNullable: true
    });
  }
}
let OrgAircraftService = /*#__PURE__*/(() => {
  class OrgAircraftService {
    constructor() {
      this._aircraftList = signal([]);
      this.aircraftService = inject(AircraftReadOnlyControllerService);
      this.selectedOrgService = inject(SelectedOrgService);
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.aircraftList = computed(() => this._aircraftList());
      this.initialized = false;
    }
    load() {
      const organizationUuid = this.config.site === 'FALA' ? this.selectedOrgService.org()?.uuid : null;
      return organizationUuid != null ? this.searchAircraft() : this.getAircraft();
    }
    isInitialized() {
      return this.initialized;
    }
    searchAircraft() {
      this._aircraftList.set([]);
      const organizationUuid = this.selectedOrgService.org()?.uuid;
      if (organizationUuid != null) {
        return this.aircraftService.searchAircraftPost({
          organizationUuid
        }).pipe(switchMap(aircraftSearchResults => {
          this._aircraftList.set(aircraftSearchResults);
          this.initialized = true;
          return EMPTY;
        }));
      } else {
        return throwError(() => new Error('No org selected'));
      }
    }
    getAircraft() {
      this._aircraftList.set([]);
      return this.aircraftService.getAircraft().pipe(switchMap(aircraftSearchResults => {
        this._aircraftList.set(aircraftSearchResults);
        this.initialized = true;
        return EMPTY;
      }));
    }
    static {
      this.ɵfac = function OrgAircraftService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgAircraftService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OrgAircraftService,
        factory: OrgAircraftService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OrgAircraftService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function buildCategorizedAndSelectablePermissions(categorizedPermissions, enabledPermissionIds) {
  return Object.fromEntries(Object.entries(categorizedPermissions).map(([category, permissions]) => [category, permissions.map(permission => {
    return {
      ...permission,
      selected: signal(enabledPermissionIds.some(permissionId => permissionId === permission.id))
    };
  })]));
}
const uniqueRoleNameValidator = (roleSummariesService, roleWizardDataService) => {
  return control => {
    const roleName = control.value;
    // Check to see if the provided role name is unique.
    // Note: if the roleWizardDataService is provided and the roleToEdit ID is defined, then the
    // control value belongs to the role summary, associated to the ID, which is currently being
    // edited in the wizard. In this case, do not consider it when searching for a duplicate.
    const isNameDuplicated = roleSummariesService.roleSummaries().some(role => role.uuid !== roleWizardDataService?.roleToEdit()?.uuid && role.name?.toLowerCase() === roleName?.toLowerCase());
    return isNameDuplicated ? {
      mustBeUnique: true
    } : null;
  };
};
let CategorizedPermissionsService = /*#__PURE__*/(() => {
  class CategorizedPermissionsService {
    constructor() {
      this.categorizedPermissions = signal({});
      this.selectedOrgService = inject(SelectedOrgService);
      this.permissionReadOnlyControllerService = inject(PermissionReadOnlyControllerService);
      this.load().pipe(takeUntilDestroyed()).subscribe({
        error: () => console.error('Unable to load categorized role permissions')
      });
    }
    load() {
      const selectedOrgUuid = this.selectedOrgService.org()?.uuid;
      return this.permissionReadOnlyControllerService.getPermissionsGroupedByCategory(false, undefined, undefined, selectedOrgUuid != null ? {
        headers: new HttpHeaders({
          'X-garmin-context-uuid': selectedOrgUuid
        })
      } : undefined).pipe(switchMap(categorizedPermissions => {
        this.categorizedPermissions.set(categorizedPermissions);
        return EMPTY;
      }), catchError(error => {
        this.categorizedPermissions.set({});
        return throwError(() => error);
      }));
    }
    static {
      this.ɵfac = function CategorizedPermissionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CategorizedPermissionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CategorizedPermissionsService,
        factory: CategorizedPermissionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CategorizedPermissionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleWizardDataService = /*#__PURE__*/(() => {
  class RoleWizardDataService {
    constructor() {
      this.roleSummariesService = inject(RoleSummariesService);
      this.categorizedPermissionsService = inject(CategorizedPermissionsService);
      this._mode = signal(null);
      this.mode = this._mode.asReadonly();
      this._roleToEdit = signal(null);
      this.roleToEdit = this._roleToEdit.asReadonly();
      this.roleNameInput = new FormControl(null, [Validators.required, uniqueRoleNameValidator(this.roleSummariesService, this)]);
      this.roleDescriptionInput = new FormControl(null);
      this.categorizedAndSelectablePermissions = computed(() => {
        const categorizedPermissions = this.categorizedPermissionsService.categorizedPermissions();
        // All roles have default organization and member read permissions
        const enabledPermissionIdSet = new Set([Permission.ORGANIZATION_READ, Permission.MEMBER_READ]);
        this.roleToEdit()?.permissions?.forEach(permission => {
          if (permission.id != null) {
            enabledPermissionIdSet.add(permission.id);
          }
        });
        const enabledPermissionIds = Array.from(enabledPermissionIdSet);
        return buildCategorizedAndSelectablePermissions(categorizedPermissions, enabledPermissionIds);
      });
      this.categorizedAndSelectedPermissions = computed(() => {
        const categorizedAndSelectablePermissions = this.categorizedAndSelectablePermissions();
        return Object.fromEntries(Object.entries(categorizedAndSelectablePermissions).map(([category, selectablePermissions]) => [category, selectablePermissions.filter(selectablePermission => selectablePermission.selected())]).filter(([_category, selectedPermissions]) => selectedPermissions.length > 0));
      });
      this.selectedPermissions = computed(() => Object.values(this.categorizedAndSelectedPermissions()).flat());
      this.selectedPermissionIds = computed(() => this.selectedPermissions().reduce((ids, permission) => {
        if (permission.id != null) {
          ids.push(permission.id);
        }
        return ids;
      }, []));
      this.categoryExpandedStates = computed(() => Object.fromEntries(Object.keys(this.categorizedPermissionsService.categorizedPermissions()).map(category => [category, signal(true)])));
      this.detailsCardExpandedState = signal(true);
      this.showPermissionDescriptions = signal(true);
    }
    initialize(roleToEdit) {
      if (roleToEdit != null) {
        this._mode.set(RoleWizardMode.EDIT);
        this._roleToEdit.set(roleToEdit);
        this.roleNameInput.setValue(roleToEdit.name ?? null);
        this.roleDescriptionInput.setValue(roleToEdit.description ?? null);
      } else {
        this._mode.set(RoleWizardMode.CREATE);
      }
    }
    static {
      this.ɵfac = function RoleWizardDataService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleWizardDataService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RoleWizardDataService,
        factory: RoleWizardDataService.ɵfac
      });
    }
  }
  return RoleWizardDataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleWizardNavigationService = /*#__PURE__*/(() => {
  class RoleWizardNavigationService {
    constructor() {
      this._step = signal(RoleWizardStep.Details);
      this.step = this._step.asReadonly();
      this.wizardSteps = [{
        state: WizardState.INCOMPLETE,
        text: 'Role Details'
      }, {
        state: WizardState.INCOMPLETE,
        text: 'Permissions'
      }, {
        state: WizardState.INCOMPLETE,
        text: 'Review'
      }];
    }
    navigateTo(destinationStep) {
      let currentStep = this.step();
      if (currentStep === destinationStep) {
        return;
      }
      // Update the wizardStep states
      const isAnAdvancement = destinationStep - currentStep > 0;
      while (currentStep != destinationStep) {
        if (isAnAdvancement) {
          this.wizardSteps[currentStep].state = WizardState.COMPLETE;
          currentStep += 1;
        } else {
          this.wizardSteps[currentStep].state = WizardState.INCOMPLETE;
          currentStep -= 1;
        }
      }
      this.wizardSteps[destinationStep].state = WizardState.INCOMPLETE;
      // Update the current step
      this._step.set(destinationStep);
    }
    goToNextStep() {
      const currentStep = this.step();
      // Do not go out of bounds
      if (currentStep === RoleWizardStep.Review) {
        return;
      }
      this.navigateTo(currentStep + 1);
    }
    goToPreviousStep() {
      const currentStep = this.step();
      // Do not go out of bounds
      if (currentStep === RoleWizardStep.Details) {
        return;
      }
      this.navigateTo(currentStep - 1);
    }
    static {
      this.ɵfac = function RoleWizardNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleWizardNavigationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RoleWizardNavigationService,
        factory: RoleWizardNavigationService.ɵfac
      });
    }
  }
  return RoleWizardNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleDetailsComponent = /*#__PURE__*/(() => {
  class RoleDetailsComponent {
    constructor() {
      this.roleWizardDataService = inject(RoleWizardDataService);
      this.header = computed(() => {
        return this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? 'ADD DETAILS' : 'UPDATE DETAILS';
      });
      this.roleNameFormControl = this.roleWizardDataService.roleNameInput;
      this.roleDescriptionFormControl = this.roleWizardDataService.roleDescriptionInput;
    }
    static {
      this.ɵfac = function RoleDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleDetailsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RoleDetailsComponent,
        selectors: [["fly-role-details"]],
        decls: 10,
        vars: 4,
        consts: [[1, "details-header"], [1, "details-content"], [1, "role-name-container"], ["label", "Role Name", "label-for", "role-name", "required", ""], ["id", "role-name", 1, "input-field", 3, "formControl"], ["label", "Role Description", 1, "role-description"], ["id", "role-description", "name", "role-description", "rows", "4", 1, "input-field", 3, "formControl"]],
        template: function RoleDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "g-input", 3);
            i0.ɵɵelement(5, "input", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, RoleDetailsComponent_Conditional_6_Template, 2, 0, "g-error");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "g-textarea", 5)(8, "textarea", 6);
            i0.ɵɵtext(9, "    ");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.header());
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("formControl", ctx.roleNameFormControl);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.roleNameFormControl.errors == null ? null : ctx.roleNameFormControl.errors["mustBeUnique"]) != null ? 6 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formControl", ctx.roleDescriptionFormControl);
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GError, i1.GInput, i1.GTextarea, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective],
        styles: [".details-header[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.details-header[_ngcontent-%COMP%]{font-size:1rem}}.details-header[_ngcontent-%COMP%]{border-bottom:1px dashed rgb(216.75,216.75,216.75);padding-bottom:1rem;margin:0 0 2rem}.details-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:2rem;background-color:#eee;border:1px solid rgb(216.75,216.75,216.75);border-radius:.5rem;padding:2rem}@media screen and (min-width: 768px){.details-content[_ngcontent-%COMP%]{flex-direction:row}}.role-name-container[_ngcontent-%COMP%]{flex:1;min-width:12.5rem}@media screen and (min-width: 768px){.role-name-container[_ngcontent-%COMP%]{max-width:18.25rem}}.role-description[_ngcontent-%COMP%]{flex:1}@media screen and (min-width: 768px){.role-description[_ngcontent-%COMP%]{padding-top:3px}}.input-field[_ngcontent-%COMP%]{background-color:#fff}"]
      });
    }
  }
  return RoleDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleWizardStepPreviewCardFrameComponent = /*#__PURE__*/(() => {
  class RoleWizardStepPreviewCardFrameComponent {
    constructor() {
      this.collapsible = false;
      this.roleWizardNavigationService = inject(RoleWizardNavigationService);
      this.roleWizardDataService = inject(RoleWizardDataService);
    }
    static {
      this.ɵfac = function RoleWizardStepPreviewCardFrameComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleWizardStepPreviewCardFrameComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RoleWizardStepPreviewCardFrameComponent,
        selectors: [["fly-role-wizard-step-preview-card-frame"]],
        inputs: {
          title: "title",
          roleWizardStep: "roleWizardStep",
          collapsible: "collapsible"
        },
        ngContentSelectors: _c4,
        decls: 4,
        vars: 1,
        consts: [["cardFrame", ""], [1, "card-frame-container", 3, "expanded"], [1, "card-frame-container"], [1, "card-frame-container", 3, "g-expand", "g-collapse", "expanded"], [4, "ngTemplateOutlet"], ["slot", "heading", 1, "card-header"], ["slot", "body", 1, "card-body"], [1, "card-frame-content"], [1, "edit-button", 3, "click", "styleObject"], [1, "edit-button-content"], ["icon", "pencil", 1, "icon", "size-small", "gray-20"]],
        template: function RoleWizardStepPreviewCardFrameComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, RoleWizardStepPreviewCardFrameComponent_Conditional_0_Template, 2, 2, "g-collapsible-region", 1)(1, RoleWizardStepPreviewCardFrameComponent_Conditional_1_Template, 2, 1, "div", 2)(2, RoleWizardStepPreviewCardFrameComponent_ng_template_2_Template, 9, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.collapsible ? 0 : 1);
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GButton, i1.GCollapsibleRegion, IconComponent, NgTemplateOutlet],
        styles: [".card-header[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.card-header[_ngcontent-%COMP%]{font-size:1rem}}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.card-frame-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;border:1px solid rgb(216.75,216.75,216.75);border-radius:.5rem;background-color:#eee;padding:1rem}.card-header[_ngcontent-%COMP%]{margin:0}.card-body[_ngcontent-%COMP%]{display:contents}.card-frame-content[_ngcontent-%COMP%]{flex:1;border-top:1px solid rgb(216.75,216.75,216.75);padding:2rem 0;margin-top:1rem}.edit-button[_ngcontent-%COMP%]{align-self:flex-start}.edit-button[_ngcontent-%COMP%]:hover   .icon[_ngcontent-%COMP%]{color:#fff}.edit-button-content[_ngcontent-%COMP%]{display:flex;gap:.75rem}.gray-20[_ngcontent-%COMP%]{color:#333}"]
      });
    }
  }
  return RoleWizardStepPreviewCardFrameComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RolePermissionsComponent = /*#__PURE__*/(() => {
  class RolePermissionsComponent {
    constructor() {
      this.roleWizardDataService = inject(RoleWizardDataService);
      this.destroyRef = inject(DestroyRef);
      this.RoleWizardStep = RoleWizardStep;
      this.Permission = Permission;
      this.roleName = this.roleWizardDataService.roleNameInput.value;
      this.roleDescription = this.roleWizardDataService.roleDescriptionInput.value;
      this.areDescriptionsShown = this.roleWizardDataService.showPermissionDescriptions;
      this.categorizedPermissions = this.roleWizardDataService.categorizedAndSelectablePermissions;
      this.categoryExpandedStates = this.roleWizardDataService.categoryExpandedStates;
    }
    ngOnInit() {
      // Determine if the initial screen width is small, and then subscribe to resize events afterwards
      this.isScreenWidthSmall = window.innerWidth < InsigniaBreakpoints.SmallScreen;
      fromEvent(window, 'resize').pipe(debounceTime(50), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.isScreenWidthSmall = window.innerWidth < InsigniaBreakpoints.SmallScreen;
      });
    }
    toggleDescriptionVisibility() {
      this.areDescriptionsShown.update(prev => !prev);
    }
    togglePermissionSelected(selectablePermission) {
      selectablePermission.selected.update(prev => !prev);
    }
    static {
      this.ɵfac = function RolePermissionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RolePermissionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RolePermissionsComponent,
        selectors: [["fly-role-permissions"]],
        decls: 14,
        vars: 7,
        consts: [["title", "Details", 1, "details-card", 3, "roleWizardStep", "collapsible"], [1, "role-details-card-name"], [1, "role-details-card-description"], [1, "permissions-section"], [1, "header"], [1, "title"], ["rightLabel", "Show descriptions"], ["type", "checkbox", 3, "change", "checked"], [1, "categories-container"], [1, "category"], [1, "collapsible-region", 3, "g-expand", "g-collapse", "expanded"], ["slot", "heading", 1, "category-title"], ["slot", "body", 1, "permissions-container"], [1, "permission-header"], [1, "permission-title"], ["size", "small", "leftLabel", "Off", "rightLabel", "On", 1, "permission-toggle"], ["type", "checkbox", 3, "change", "checked", "disabled"], [1, "permission-description"]],
        template: function RolePermissionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "fly-role-wizard-step-preview-card-frame", 0)(1, "h3", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, RolePermissionsComponent_Conditional_3_Template, 2, 1, "p", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "section", 3)(5, "header", 4)(6, "h2", 5);
            i0.ɵɵtext(7, "SET PERMISSIONS");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "g-switch", 6)(9, "input", 7);
            i0.ɵɵlistener("change", function RolePermissionsComponent_Template_input_change_9_listener() {
              return ctx.toggleDescriptionVisibility();
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 8);
            i0.ɵɵrepeaterCreate(11, RolePermissionsComponent_For_12_Template, 7, 2, "div", 9, _forTrack2);
            i0.ɵɵpipe(13, "keyvalue");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("roleWizardStep", ctx.RoleWizardStep.Details)("collapsible", ctx.isScreenWidthSmall);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.roleName);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.roleDescription != null ? 3 : -1);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("checked", ctx.areDescriptionsShown());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(i0.ɵɵpipeBind1(13, 5, ctx.categorizedPermissions()));
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GCollapsibleRegion, i1.GSwitch, KeyValuePipe, RoleWizardStepPreviewCardFrameComponent],
        styles: [".header[_ngcontent-%COMP%] > .title[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.header[_ngcontent-%COMP%] > .title[_ngcontent-%COMP%]{font-size:1rem}}.role-details-card-name[_ngcontent-%COMP%]{margin:0;font-weight:700}.role-details-card-description[_ngcontent-%COMP%]{color:#333;margin-top:1rem}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:2rem}@media screen and (min-width: 768px){[_nghost-%COMP%]{flex-direction:row}.details-card[_ngcontent-%COMP%]{flex:0 0 15rem;align-self:flex-start}.permissions-section[_ngcontent-%COMP%]{flex:1}}.header[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:.25rem;border-bottom:1px dashed rgb(216.75,216.75,216.75);padding-bottom:1rem;margin-bottom:2rem}.header[_ngcontent-%COMP%] > .title[_ngcontent-%COMP%]{margin:0}.categories-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:1rem}.category[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);border-radius:.5rem;padding:1rem 2rem 2rem}.collapsible-region[_ngcontent-%COMP%]{margin-bottom:0}.category-title[_ngcontent-%COMP%]{margin:0}.permissions-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fill,minmax(auto,17.5rem));column-gap:5rem;row-gap:2rem;border:1px solid rgb(216.75,216.75,216.75);border-radius:.5rem;padding:1.5rem;margin-top:1rem;background-color:#eee}.permission-title[_ngcontent-%COMP%]{font-size:.875rem;font-weight:700;margin:0 0 .5rem}.permission-description[_ngcontent-%COMP%]{font-size:.875rem;color:#333}.permission-toggle[_ngcontent-%COMP%]{display:block;margin-top:1rem}.permission-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:baseline;gap:.5rem}"]
      });
    }
  }
  return RolePermissionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleReviewComponent = /*#__PURE__*/(() => {
  class RoleReviewComponent {
    constructor() {
      this.roleWizardDataService = inject(RoleWizardDataService);
      this.subheading = computed(() => {
        return this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? 'Review details of the new role you are about to create' : 'Review details of the role you are about to update';
      });
      this.RoleWizardStep = RoleWizardStep;
      this.roleName = this.roleWizardDataService.roleNameInput.value;
      this.roleDescription = this.roleWizardDataService.roleDescriptionInput.value;
      this.categorizedSelectedPermissions = this.roleWizardDataService.categorizedAndSelectedPermissions;
    }
    static {
      this.ɵfac = function RoleReviewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleReviewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RoleReviewComponent,
        selectors: [["fly-role-review"]],
        decls: 15,
        vars: 7,
        consts: [[1, "title"], [1, "subheading"], [1, "preview-card-container"], ["title", "Details", 1, "details-card", 3, "roleWizardStep"], [1, "role-details-card-name"], [1, "role-details-card-description"], ["title", "Permissions", 3, "roleWizardStep"], [1, "permissions-card-permission-grid"], [1, "permissions-card-permission-category"], [1, "permissions-card-permission-title"]],
        template: function RoleReviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "header")(1, "h2", 0);
            i0.ɵɵtext(2, "REVIEW");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "h3", 1);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 2)(6, "fly-role-wizard-step-preview-card-frame", 3)(7, "h3", 4);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, RoleReviewComponent_Conditional_9_Template, 2, 1, "p", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "fly-role-wizard-step-preview-card-frame", 6)(11, "dl", 7);
            i0.ɵɵrepeaterCreate(12, RoleReviewComponent_For_13_Template, 5, 1, "div", null, _forTrack2);
            i0.ɵɵpipe(14, "keyvalue");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.subheading());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("roleWizardStep", ctx.RoleWizardStep.Details);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.roleName);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.roleDescription != null ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("roleWizardStep", ctx.RoleWizardStep.Permissions);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(i0.ɵɵpipeBind1(14, 5, ctx.categorizedSelectedPermissions()));
          }
        },
        dependencies: [KeyValuePipe, RoleWizardStepPreviewCardFrameComponent],
        styles: [".title[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.title[_ngcontent-%COMP%]{font-size:1rem}}.role-details-card-name[_ngcontent-%COMP%]{margin:0;font-weight:700}.role-details-card-description[_ngcontent-%COMP%]{color:#333;margin-top:1rem}.title[_ngcontent-%COMP%]{border-bottom:1px solid #000;padding-bottom:.625rem;margin:0 0 .5rem}.subheading[_ngcontent-%COMP%]{font-family:Roboto;letter-spacing:0;font-size:.875rem;color:#666;margin-bottom:2.5rem}.preview-card-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr;gap:.875rem}@media screen and (min-width: 768px){.preview-card-container[_ngcontent-%COMP%]{grid-template-columns:1fr 1fr}}.details-card[_ngcontent-%COMP%]{align-self:stretch}.permissions-card-permission-grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fill,minmax(auto,9.75rem));column-gap:1.5rem;row-gap:2.5rem}@media screen and (min-width: 768px){.permissions-card-permission-grid[_ngcontent-%COMP%]{max-height:15rem;overflow-y:auto}}.permissions-card-permission-category[_ngcontent-%COMP%]{font-weight:700}.permissions-card-permission-title[_ngcontent-%COMP%]{font-size:.875rem}"]
      });
    }
  }
  return RoleReviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleWizardComponent = /*#__PURE__*/(() => {
  class RoleWizardComponent extends UnsavedChanges {
    constructor() {
      super();
      this.roleWizardNavigationService = inject(RoleWizardNavigationService);
      this.roleWizardDataService = inject(RoleWizardDataService);
      this.activatedRoute = inject(ActivatedRoute);
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.roleSummariesService = inject(RoleSummariesService);
      this.rolesService = inject(RolesService);
      this.router = inject(Router);
      this.selectedOrgService = inject(SelectedOrgService);
      this.submitModal = computed(() => this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? this.createSubmissionModal : this.updateSubmissionModal);
      this.cancelRoute = undefined;
      this.unsavedChanges = signal(true); // always trigger for unsaved or no changes.
      this.RoleWizardStep = RoleWizardStep;
      this.state = signal(null);
      this.submitState = signal(null);
      this.roleWizardTitle = computed(() => this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? 'CREATE NEW ROLE' : 'UPDATE ROLE');
      this.roleWizardDescription = computed(() => this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? `Create a new role for members in your organization. Members assigned \
         to this role will be given the specific permissions that you select. \
         You will be able to immediately assign members to this role at the end \
         of the process.` : `Update the settings of a previously created role. Members currently \
         assigned to this role will receive any changes made to the role's \
         details or permissions.`);
      this.submitButtonText = computed(() => this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? 'Create Role' : 'Update Role');
      this.submitErrorText = computed(() => {
        return `THERE WAS AN ERROR ${this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? 'CREATING' : 'UPDATING'} THIS ROLE`;
      });
      this.goToHomePage = () => {
        this.submitModal().close();
        const orgPath = this.config.site === 'FALA' ? `/orgs/${this.selectedOrgService.org()?.uuid}` : '/org';
        this.router.navigate([orgPath]);
      };
      this.goToRoleManagement = () => {
        this.submitModal().close();
        const rolesPath = this.config.site === 'FALA' ? `/orgs/${this.selectedOrgService.org()?.uuid}/roles` : '/org/roles';
        this.router.navigate([rolesPath]);
      };
      this.goToMemberAssignment = () => {
        this.submitModal().close();
        const membersPath = this.config.site === 'FALA' ? `/orgs/${this.selectedOrgService.org()?.uuid}/members` : '/org/members';
        this.router.navigate([membersPath]);
      };
      const navigation = this.router.getCurrentNavigation();
      const orgPath = this.config.site === 'FALA' ? `/orgs/${this.selectedOrgService.org()?.uuid}` : '/org';
      if (navigation?.extras?.state?.['back'] === 'roles') {
        this.cancelRoute = `${orgPath}/roles`;
      } else {
        this.cancelRoute = `${orgPath}`;
      }
    }
    ngOnInit() {
      super.ngOnInit();
      const id = this.activatedRoute.snapshot.paramMap.get('id');
      if (id == null) {
        // If a role ID is not provided in the route parameters, then the wizard is in CREATE mode.
        this.roleWizardDataService.initialize();
        this.state.set('LOADED');
      } else {
        // If a role ID is provided, then the wizard is in EDIT mode. Find the role summary to edit and pass it
        // to the wizard service.
        const loadRoleSummaries$ = this.roleSummariesService.isInitialized() ? EMPTY : this.roleSummariesService.load();
        this.state.set('LOADING');
        loadRoleSummaries$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
          complete: () => {
            const roleToEdit = this.roleSummariesService.getRoleById(id, false);
            if (roleToEdit != null) {
              this.roleWizardDataService.initialize(roleToEdit);
              this.state.set('LOADED');
            } else {
              this.state.set('ERROR');
            }
          },
          error: () => this.state.set('ERROR')
        });
      }
    }
    onSubmit() {
      this.submitState.set('LOADING');
      const role = this.buildCustomRole();
      const selectedPermissionIds = this.roleWizardDataService.selectedPermissionIds();
      const submitObservable$ = this.roleWizardDataService.mode() === RoleWizardMode.CREATE ? this.createCustomRole(role, selectedPermissionIds) : this.updateCustomRole(role, selectedPermissionIds);
      submitObservable$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => {
          this.submitState.set('LOADED');
          this.unsavedChanges.set(false);
          this.submitModal().open();
        },
        error: () => {
          this.submitState.set('ERROR');
        }
      });
    }
    createCustomRole(role, selectedPermissionIds) {
      return this.rolesService.createCustomRole(role).pipe(concatMap(createdRole => {
        return this.rolesService.updateCustomRolePermissions(createdRole.uuid, selectedPermissionIds).pipe(map(permissions => [createdRole, permissions]), catchError(error => {
          // If the role is successfully created but the permissions fail to get assigned, then attempt
          // to clean up the partially created role and forward the error.
          return this.rolesService.deleteCustomRole(createdRole.uuid).pipe(concatMap(() => throwError(() => new Error(error))));
        }));
      }));
    }
    updateCustomRole(role, selectedPermissionIds) {
      return forkJoin([this.rolesService.updateCustomRole(role), this.rolesService.updateCustomRolePermissions(role.uuid, selectedPermissionIds)]);
    }
    buildCustomRole() {
      return {
        uuid: this.roleWizardDataService.roleToEdit()?.uuid,
        organizationUuid: this.selectedOrgService.org()?.uuid,
        name: this.roleWizardDataService.roleNameInput.value ?? undefined,
        description: this.roleWizardDataService.roleDescriptionInput.value ?? undefined,
        garminDefined: false,
        roleTypeId: MEMBER_ROLE_TYPE_ID
      };
    }
    static {
      this.ɵfac = function RoleWizardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RoleWizardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RoleWizardComponent,
        selectors: [["fly-role-wizard"]],
        viewQuery: function RoleWizardComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5);
            i0.ɵɵviewQuery(_c7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createSubmissionModal = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.updateSubmissionModal = _t.first);
          }
        },
        features: [i0.ɵɵProvidersFeature([RoleWizardNavigationService, RoleWizardDataService]), i0.ɵɵInheritDefinitionFeature],
        decls: 33,
        vars: 35,
        consts: [["backButton", ""], ["nextButton", ""], ["createSubmissionModal", ""], ["updateSubmissionModal", ""], ["type", "error", "closeable", "false", "leftIcon", "true"], [1, "role-wizard-title"], [1, "role-wizard-description"], [1, "wizard-header"], [1, "wizard-header-steps", 3, "currentIndex", "wizardSteps"], [1, "wizard-controls"], ["type", "dark", 1, "loader"], [1, "error"], [3, "header", "buttons", "showCloseBtn", "disableExternalClose"], [1, "submit-outcome-info"], [1, "submit-outcome-navigation-query"], [3, "click", "styleObject", "disabled"], ["theme", "black", "chevron", "true", 3, "click", "disabled", "styleObject"], [1, "error-banner-content"], [3, "click"], [3, "routerLink"], [3, "styleObject"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet"], ["theme", "black", 3, "click", "styleObject", "disabled"], [1, "submit-button-content"], ["type", "dark", 1, "button-loader"]],
        template: function RoleWizardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, RoleWizardComponent_ng_template_0_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, RoleWizardComponent_ng_template_2_Template, 2, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, RoleWizardComponent_Conditional_4_Template, 6, 1, "g-alert", 4);
            i0.ɵɵelementStart(5, "header")(6, "h1", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "p", 6);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵelement(11, "fly-wizard-header", 8);
            i0.ɵɵelementStart(12, "div", 9);
            i0.ɵɵtemplate(13, RoleWizardComponent_Case_13_Template, 4, 7)(14, RoleWizardComponent_Case_14_Template, 2, 5)(15, RoleWizardComponent_Case_15_Template, 5, 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(16, RoleWizardComponent_Case_16_Template, 1, 0, "g-loader", 10)(17, RoleWizardComponent_Case_17_Template, 3, 1)(18, RoleWizardComponent_Case_18_Template, 2, 0, "g-error", 11);
            i0.ɵɵelementStart(19, "fly-modal", 12, 2);
            i0.ɵɵpipe(21, "uppercase");
            i0.ɵɵelementStart(22, "p", 13);
            i0.ɵɵtext(23, "You can now assign this role to any of the members of your organization.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "p", 14);
            i0.ɵɵtext(25, "Would you like to select members to assign this role to now?");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(26, "fly-modal", 12, 3);
            i0.ɵɵpipe(28, "uppercase");
            i0.ɵɵelementStart(29, "p", 13);
            i0.ɵɵtext(30, " The updated role settings have been applied to all members who are currently assigned this role. ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "p", 14);
            i0.ɵɵtext(32, "Would you like to return to role management?");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_9_0;
            let tmp_10_0;
            let tmp_11_0;
            let tmp_15_0;
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.submitState() === "ERROR" ? 4 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.roleWizardTitle());
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.roleWizardDescription());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("currentIndex", ctx.roleWizardNavigationService.step())("wizardSteps", ctx.roleWizardNavigationService.wizardSteps);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_9_0 = ctx.roleWizardNavigationService.step()) === ctx.RoleWizardStep.Details ? 13 : tmp_9_0 === ctx.RoleWizardStep.Permissions ? 14 : tmp_9_0 === ctx.RoleWizardStep.Review ? 15 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((tmp_10_0 = ctx.state()) === "LOADING" ? 16 : tmp_10_0 === "LOADED" ? 17 : tmp_10_0 === "ERROR" ? 18 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("header", "", i0.ɵɵpipeBind1(21, 17, (tmp_11_0 = ctx.roleWizardDataService.roleNameInput.value) !== null && tmp_11_0 !== undefined ? tmp_11_0 : "N/A"), " CREATED");
            i0.ɵɵproperty("buttons", i0.ɵɵpureFunction2(25, _c3, i0.ɵɵpureFunction1(21, _c8, ctx.goToHomePage), i0.ɵɵpureFunction1(23, _c9, ctx.goToMemberAssignment)))("showCloseBtn", false)("disableExternalClose", true);
            i0.ɵɵadvance(7);
            i0.ɵɵpropertyInterpolate1("header", "", i0.ɵɵpipeBind1(28, 19, (tmp_15_0 = ctx.roleWizardDataService.roleNameInput.value) !== null && tmp_15_0 !== undefined ? tmp_15_0 : "N/A"), " UPDATED");
            i0.ɵɵproperty("buttons", i0.ɵɵpureFunction2(32, _c3, i0.ɵɵpureFunction1(28, _c8, ctx.goToHomePage), i0.ɵɵpureFunction1(30, _c10, ctx.goToRoleManagement)))("showCloseBtn", false)("disableExternalClose", true);
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GAlert, i1.GButton, i1.GError, i1.GLoader, ModalComponent, NgTemplateOutlet, RoleDetailsComponent, RolePermissionsComponent, RoleReviewComponent, RouterLink, UpperCasePipe, WizardHeaderComponent],
        styles: [".role-wizard-title[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){.role-wizard-title[_ngcontent-%COMP%]{font-size:2rem}}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.error-banner-content[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.error-banner-content[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{text-decoration:underline}.role-wizard-description[_ngcontent-%COMP%]{color:#737373;margin-bottom:.5rem}.wizard-header[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;margin-bottom:1.5rem}@media screen and (min-width: 768px){.wizard-header[_ngcontent-%COMP%]{flex-direction:row;justify-content:space-between;align-items:center}}.wizard-header-steps[_ngcontent-%COMP%]{gap:1rem}@media screen and (min-width: 768px){.wizard-header-steps[_ngcontent-%COMP%]{gap:3.75rem}}.wizard-controls[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:.5rem;margin-left:auto}.submit-button-content[_ngcontent-%COMP%]{width:6rem;display:flex;justify-content:center;align-items:center;gap:.5rem}.submit-button-content[_ngcontent-%COMP%] > .button-loader[_ngcontent-%COMP%]{width:50%}.white[_ngcontent-%COMP%]{color:#fff}.loader[_ngcontent-%COMP%]{margin:1.5rem auto}.error[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-top:1.5rem}.submit-outcome-info[_ngcontent-%COMP%]{color:#737373}.submit-outcome-navigation-query[_ngcontent-%COMP%]{margin-top:1rem}"]
      });
    }
  }
  return RoleWizardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MemberInvitesService = /*#__PURE__*/(() => {
  class MemberInvitesService {
    constructor() {
      this.pendingInvites = computed(() => this._pendingInvites());
      this.selectedOrgService = inject(SelectedOrgService);
      this.invitesReadService = inject(MembershipInviteReadOnlyControllerService);
      this.invitesWriteService = inject(MembershipInviteWriteControllerService);
      this._pendingInvites = signal([]);
      this.load().pipe(takeUntilDestroyed()).subscribe({
        error: () => console.error('Unable to load pending invites')
      });
    }
    /**
     * Loads MembershipInvites into the {@link pendingInvites} {@link Signal}
     *
     * @returns {Observable<never>} that simply completes if loaded successfully or errors otherwise.
     */
    load() {
      this._pendingInvites.set([]);
      const orgUuid = this.selectedOrgService.org()?.uuid;
      return orgUuid == null ? throwError(() => new Error('No org selected')) : this.invitesReadService.searchMembershipInvites({
        organizationUuid: orgUuid
      }).pipe(switchMap(inviteSummaries => {
        this._pendingInvites.set(inviteSummaries);
        return EMPTY;
      }));
    }
    sendInvites(invites) {
      return forkJoin(invites.map(invite => this.invitesWriteService.createMembershipInvite(invite))).pipe(switchMap(() => {
        return this.load();
      }));
    }
    deleteInvite(uuid) {
      return this.invitesWriteService.deleteMembershipInvite(uuid).pipe(switchMap(() => {
        this._pendingInvites.update(prev => prev.filter(i => i.uuid !== uuid));
        return EMPTY;
      }), catchError(error => {
        console.error(`An error ocurred deleting invite for uuid: ${uuid} \n`, error.error);
        throw new Error('Unable to delete invite');
      }));
    }
    static {
      this.ɵfac = function MemberInvitesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MemberInvitesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MemberInvitesService,
        factory: MemberInvitesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MemberInvitesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var PillTheme = /*#__PURE__*/function (PillTheme) {
  PillTheme[PillTheme["DEFAULT"] = 0] = "DEFAULT";
  PillTheme[PillTheme["SUCCESS"] = 1] = "SUCCESS";
  PillTheme[PillTheme["INVALID"] = 2] = "INVALID";
  PillTheme[PillTheme["ERROR"] = 3] = "ERROR";
  return PillTheme;
}(PillTheme || {});
let EmailPillComponent = /*#__PURE__*/(() => {
  class EmailPillComponent {
    constructor() {
      this.theme = PillTheme.DEFAULT;
      this.closeClicked = new EventEmitter();
      this.PillTheme = PillTheme;
    }
    ngOnInit() {
      switch (this.theme) {
        case PillTheme.ERROR:
          this.icon = 'error';
          break;
        case PillTheme.SUCCESS:
          this.icon = 'checkmark';
          break;
        default:
          this.icon = 'close';
      }
    }
    static {
      this.ɵfac = function EmailPillComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EmailPillComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EmailPillComponent,
        selectors: [["fly-orgs-email-pill"]],
        inputs: {
          text: "text",
          theme: "theme"
        },
        outputs: {
          closeClicked: "closeClicked"
        },
        decls: 3,
        vars: 14,
        consts: [["slot", "trailing-icon", 1, "delete-pill", 3, "click", "icon"]],
        template: function EmailPillComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "g-chip");
            i0.ɵɵtext(1);
            i0.ɵɵelementStart(2, "fly-icon", 0);
            i0.ɵɵlistener("click", function EmailPillComponent_Template_fly_icon_click_2_listener() {
              return ctx.closeClicked.emit(ctx.text);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("default", ctx.theme === ctx.PillTheme.DEFAULT)("success", ctx.theme === ctx.PillTheme.SUCCESS)("error", ctx.theme === ctx.PillTheme.ERROR || ctx.theme === ctx.PillTheme.INVALID);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.text, " ");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("success", ctx.theme === ctx.PillTheme.SUCCESS)("error", ctx.theme === ctx.PillTheme.ERROR || ctx.theme === ctx.PillTheme.INVALID)("pointer", ctx.theme === ctx.PillTheme.INVALID || ctx.theme === ctx.PillTheme.DEFAULT);
            i0.ɵɵproperty("icon", ctx.icon);
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GChip, IconComponent],
        styles: [".default[_ngcontent-%COMP%]{border-color:#d9d9d9}.success[_ngcontent-%COMP%]{border-color:transparent;background-color:#b7e1b9;color:#2d6c30}.error[_ngcontent-%COMP%]{border-color:#920000;color:#920000}.delete-pill[_ngcontent-%COMP%]{width:.75rem;height:.75rem;cursor:pointer}"]
      });
    }
  }
  return EmailPillComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const INVALID_EMAIL_MESSAGE = 'Email is invalid';
const INVALID_EMAIL_DOMAIN_MESSAGE = 'Email domain invalid for this organization';
let InvitationModalComponent = /*#__PURE__*/(() => {
  class InvitationModalComponent {
    constructor() {
      this.destroyRef = inject(DestroyRef);
      this.selectedOrgService = inject(SelectedOrgService);
      this.inviteService = inject(MemberInvitesService);
      this.orgSettingsService = inject(ORG_SETTINGS_SERVICE_TOKEN);
      this.roleService = inject(RolesService);
      this.fg = new FormGroup({
        email: new FormControl('', [Validators.pattern(emailRegEx), Validators.required])
      });
      this.PillTheme = PillTheme;
      this.errorText = '';
      this.state = 'initialized';
      this.selectedRole = null;
      this.emails = [];
    }
    ngOnInit() {
      const orgUuid = this.selectedOrgService.org()?.uuid;
      if (orgUuid != null) {
        this.orgUuid = orgUuid;
        this.defaultRole = MEMBER_ROLE;
      } else {
        this.state = 'error';
        this.errorText = 'You must set an active organization to invite users';
      }
    }
    open() {
      this.modal.open();
    }
    close() {
      this.modal.close();
      this.reset();
    }
    submit() {
      this.state = 'submitting';
      const invites = [];
      const role = this.selectedRole?.uuid ?? this.defaultRole.uuid;
      for (const email of this.emails) {
        invites.push({
          organizationUuid: this.orgUuid,
          roleUuids: [role],
          recipientEmailAddress: email
        });
      }
      this.inviteService.sendInvites(invites).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => {
          this.state = 'submitted';
        },
        error: error => {
          this.state = 'error';
          if (invites.length === 1) {
            this.errorText = error.status === HttpStatusCode.Conflict ? 'This user has already been invited to the organization' : 'Something went wrong sending the invitation';
          } else {
            this.errorText = error.status === HttpStatusCode.Conflict ? 'At least one of these users have already been invited to the organization' : 'Something went wrong sending the invitations';
          }
        }
      });
    }
    addEmail() {
      if (!this.fg.controls.email.valid) {
        this.errorText = INVALID_EMAIL_MESSAGE;
        return;
      }
      const email = this.fg.controls.email.value;
      if (this.orgSettingsService.useCustomDomainList.value) {
        const domainRegExp = new RegExp(`.*(${this.orgSettingsService.allowedEmailDomains().join('|')})`);
        if (!domainRegExp.test(email)) {
          this.errorText = INVALID_EMAIL_DOMAIN_MESSAGE;
          return;
        }
      }
      this.errorText = '';
      this.emails.push(email);
      this.fg.reset();
    }
    removeEmail(email) {
      if (this.state === 'submitting') return;
      // always remove the pill if user is clicking the 'x'
      const fromClick = typeof email === 'string';
      if (fromClick || this.fg.controls.email.value === null || this.fg.controls.email.value === '') {
        this.emails.splice(this.emails.indexOf(email), 1);
      }
    }
    selectRole(event) {
      this.selectedRole = this.roleService.roles().find(r => r.uuid === event.target.value) ?? null;
    }
    reset() {
      this.errorText = '';
      this.state = 'initialized';
      this.emails = [];
      this.fg.reset();
    }
    noSort() {
      return 1;
    }
    static {
      this.ɵfac = function InvitationModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InvitationModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InvitationModalComponent,
        selectors: [["fly-orgs-invitation-modal"]],
        viewQuery: function InvitationModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
          }
        },
        hostBindings: function InvitationModalComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.enter", function InvitationModalComponent_keydown_enter_HostBindingHandler($event) {
              return ctx.addEmail($event);
            })("keydown.backspace", function InvitationModalComponent_keydown_backspace_HostBindingHandler($event) {
              return ctx.removeEmail($event);
            });
          }
        },
        decls: 41,
        vars: 11,
        consts: [["modal", ""], ["header", "Invite People to Join", 3, "closed"], [1, "body"], [1, "subtext"], [1, "input-container"], [1, "email-label"], [1, "email-list", 3, "formGroup"], [3, "text", "hidden"], ["text", "Invitations Sent", 3, "theme", "hidden"], ["text", "Error", 3, "theme", "hidden"], ["id", "email", "formControlName", "email"], [1, "subtext-error"], [1, "subtext-info"], [1, "role-assignment"], [1, "filter"], ["label", "Assign a Role (Optional)", 1, "role-dropdown"], ["name", "role-select", 3, "change"], ["selected", ""], [3, "value"], [1, "footer"], [1, "divider"], [1, "role-note"], [1, "invite-button", 3, "click", "disabled"], [1, "loader-container"], [3, "closeClicked", "text", "hidden"], ["type", "dark"]],
        template: function InvitationModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "fly-modal", 1, 0);
            i0.ɵɵlistener("closed", function InvitationModalComponent_Template_fly_modal_closed_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.reset());
            });
            i0.ɵɵelementStart(2, "form", 2)(3, "div", 3);
            i0.ɵɵtext(4, " Send an invite directly to a person\u2019s email. You may add multiple emails at once to invite a large number of people to join your organization. ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
            i0.ɵɵtext(7, "Email Address");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵrepeaterCreate(9, InvitationModalComponent_For_10_Template, 1, 2, "fly-orgs-email-pill", 7, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelement(11, "fly-orgs-email-pill", 8)(12, "fly-orgs-email-pill", 9)(13, "input", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 3)(15, "div", 11);
            i0.ɵɵtext(16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "div", 12);
            i0.ɵɵtext(18, "Press Enter to add email");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "div", 13)(20, "div", 14)(21, "g-drop-down", 15)(22, "select", 16);
            i0.ɵɵlistener("change", function InvitationModalComponent_Template_select_change_22_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectRole($event));
            });
            i0.ɵɵelementStart(23, "option", 17);
            i0.ɵɵtext(24, "Select Role");
            i0.ɵɵelementEnd();
            i0.ɵɵrepeaterCreate(25, InvitationModalComponent_For_26_Template, 2, 2, "option", 18, _forTrack0);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(27, "div", 3)(28, "div", 12);
            i0.ɵɵtext(29, " - This role will be automatically assigned to ");
            i0.ɵɵelementStart(30, "strong");
            i0.ɵɵtext(31, "ALL");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(32, " of the people you are inviting above. ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "div", 12);
            i0.ɵɵtext(34, " - You can assign more roles to a member after they accept the invite to join your organization. ");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(35, "div", 19);
            i0.ɵɵelement(36, "div", 20);
            i0.ɵɵtemplate(37, InvitationModalComponent_Conditional_37_Template, 3, 1, "div", 21);
            i0.ɵɵelementStart(38, "button", 22);
            i0.ɵɵlistener("click", function InvitationModalComponent_Template_button_click_38_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.submit());
            });
            i0.ɵɵtemplate(39, InvitationModalComponent_Case_39_Template, 2, 0, "div", 23)(40, InvitationModalComponent_Case_40_Template, 1, 0);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            let tmp_12_0;
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("formGroup", ctx.fg);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.emails);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("theme", ctx.PillTheme.SUCCESS)("hidden", ctx.state !== "submitted");
            i0.ɵɵadvance();
            i0.ɵɵproperty("theme", ctx.PillTheme.ERROR)("hidden", ctx.state !== "error");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.errorText);
            i0.ɵɵadvance(9);
            i0.ɵɵrepeater(ctx.roleService.roles());
            i0.ɵɵadvance(12);
            i0.ɵɵconditional(ctx.selectedRole != null ? 37 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("disabled-button", ctx.state !== "initialized" || ctx.emails.length < 1);
            i0.ɵɵproperty("disabled", ctx.state !== "initialized" || ctx.emails.length < 1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_12_0 = ctx.state) === "submitting" ? 39 : 40);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GDropDown, i1.GLoader, ReactiveFormsModule, i2.ɵNgNoValidate, i2.NgSelectOption, i2.ɵNgSelectMultipleOption, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, FormsModule, i2.NgForm, EmailPillComponent, ModalComponent],
        styles: [".body[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:left;max-width:41rem;overflow:hidden;gap:1rem}.body[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]{font-size:16px;line-height:1.5rem;letter-spacing:0;color:#737373;text-align:left}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]{margin-right:1.5rem;flex-grow:1}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .email-label[_ngcontent-%COMP%]{font-size:.875rem;font-weight:500;line-height:1rem;letter-spacing:0;text-align:left;margin-bottom:.75rem}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .email-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;min-height:2.5rem;border:.5px solid rgb(216.75,216.75,216.75);align-items:center;padding:.33rem;gap:.5rem}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .email-list[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:none;font-size:16px;color:#737373;text-align:left;flex:1 0 auto}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .email-list[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]   .subtext-error[_ngcontent-%COMP%]{font-size:.875rem;color:#920000;margin-top:.25rem}.body[_ngcontent-%COMP%]   .input-container[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]   .subtext-info[_ngcontent-%COMP%]{font-size:.6875rem;line-height:.875rem;letter-spacing:0;color:#737373;margin-top:.5rem;text-align:right}.body[_ngcontent-%COMP%]   .role-assignment[_ngcontent-%COMP%]{text-align:left}.body[_ngcontent-%COMP%]   .role-assignment[_ngcontent-%COMP%]   .role-dropdown[_ngcontent-%COMP%]{font-size:.85rem;font-weight:500;line-height:1rem;letter-spacing:0;color:#737373}.body[_ngcontent-%COMP%]   .role-assignment[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]{font-size:.875rem;width:fit-content}.body[_ngcontent-%COMP%]   .role-assignment[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]{display:block;justify-content:space-between}.body[_ngcontent-%COMP%]   .role-assignment[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]   .subtext-info[_ngcontent-%COMP%]{margin-top:.2rem;font-size:.6875rem;line-height:.875rem;letter-spacing:0;color:#737373}.loader-container[_ngcontent-%COMP%]{display:flex;justify-content:center}.loader-container[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{max-width:4rem}.footer[_ngcontent-%COMP%]{margin-top:1rem}.footer[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]{margin-bottom:1rem;border:1px solid rgb(216.75,216.75,216.75)}.footer[_ngcontent-%COMP%]   .role-note[_ngcontent-%COMP%]{font-size:.875rem;font-weight:700;line-height:1rem;letter-spacing:0;text-align:left;margin-bottom:.75rem}.footer[_ngcontent-%COMP%]   .invite-button[_ngcontent-%COMP%]{font-size:.875rem;font-weight:500;line-height:1rem;width:100%;min-width:5.75rem;height:2.5rem;background:#000;color:#fff;border:1px solid #000;text-align:center;cursor:pointer}.footer[_ngcontent-%COMP%]   .invite-button[_ngcontent-%COMP%]:hover{font-weight:400;background:#fff;color:#000}.footer[_ngcontent-%COMP%]   .invite-button[_ngcontent-%COMP%]:focus-visible{background:#fff;color:#000}.footer[_ngcontent-%COMP%]   .invite-button.disabled-button[_ngcontent-%COMP%]{pointer-events:none;color:#000;background:#d9d9d9;border:none}"]
      });
    }
  }
  return InvitationModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PendingInvitationsTableComponent = /*#__PURE__*/(() => {
  class PendingInvitationsTableComponent {
    constructor() {
      this.maxPerPage = 5;
      this.destroyRef = inject(DestroyRef);
      this.memberInvitesService = inject(MemberInvitesService);
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
      this.currentPageInvites = computed(() => {
        const invites = this.memberInvitesService.pendingInvites();
        if (this.showAll()) return invites;
        const start = (this.currentPage() - 1) * this.maxPerPage;
        return invites.slice(start, start + this.maxPerPage);
      });
      this.totalInvites = computed(() => this.memberInvitesService.pendingInvites().length);
      this.currentPage = signal(1);
      this.totalPages = computed(() => Math.ceil(this.memberInvitesService.pendingInvites().length / this.maxPerPage));
      this.showAll = signal(false);
      this.errorText = '';
    }
    deleteInvite(invite) {
      this.memberInvitesService.deleteInvite(invite.uuid ?? '').pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => {
          this.errorText = '';
        },
        error: () => {
          this.errorText = `There was an error deleting membership invite for ${invite.recipientEmailAddress}.`;
        }
      });
    }
    static {
      this.ɵfac = function PendingInvitationsTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PendingInvitationsTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PendingInvitationsTableComponent,
        selectors: [["fly-orgs-pending-invites-table"]],
        decls: 10,
        vars: 6,
        consts: [[1, "grid"], [1, "row", "header"], [1, "label"], [1, "row", "data"], ["label", "Pending Invites", 3, "count", "total", "currentPage", "totalPages", "showAll"], [1, "error"], [1, "role"], [1, "control-buttons"], ["size", "small", 3, "click"], [1, "control-button-text"], ["icon", "error", 1, "icon"]],
        template: function PendingInvitationsTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵtext(3, "Email");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span", 2);
            i0.ɵɵtext(5, "Role");
            i0.ɵɵelementEnd()();
            i0.ɵɵrepeaterCreate(6, PendingInvitationsTableComponent_For_7_Template, 7, 2, "div", 3, _forTrack0);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "fly-page-controls", 4);
            i0.ɵɵtemplate(9, PendingInvitationsTableComponent_Conditional_9_Template, 3, 1, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵrepeater(ctx.currentPageInvites());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("count", ctx.currentPageInvites().length)("total", ctx.memberInvitesService.pendingInvites().length)("currentPage", ctx.currentPage)("totalPages", ctx.totalPages())("showAll", ctx.showAll);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.errorText ? 9 : -1);
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GButton, CommonModule, IconComponent, PageControlsComponent],
        styles: [".header[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem}.grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:auto}.header[_ngcontent-%COMP%]{text-transform:uppercase;border-bottom:2px solid #000;-webkit-user-select:none;user-select:none}.header[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.header[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{display:flex;height:fit-content;padding:1rem}}.row[_ngcontent-%COMP%]{display:grid;grid-column:1/-1;grid-template-columns:auto;grid-template-rows:repeat(auto-fit,minmax(0,max-content));gap:.25rem;padding:1rem}@media screen and (min-width: 768px){.row[_ngcontent-%COMP%]{grid-template-columns:subgrid;grid-template-rows:subgrid;gap:0;padding:0}}.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:0}@media screen and (min-width: 768px){.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:1rem}}.single-item-row[_ngcontent-%COMP%]{grid-column:1/-1}.hidden[_ngcontent-%COMP%]{display:none}.data[_ngcontent-%COMP%]{border-bottom:1px solid rgb(216.75,216.75,216.75)}.control-buttons[_ngcontent-%COMP%]{justify-self:end;display:flex;flex-direction:column;justify-content:flex-end;gap:.5rem}.control-buttons[_ngcontent-%COMP%]   .control-button-text[_ngcontent-%COMP%]{display:inline-block;min-width:3rem}@media screen and (min-width: 768px){.control-buttons[_ngcontent-%COMP%]{flex-direction:row}.control-buttons[_ngcontent-%COMP%]   .control-button-text[_ngcontent-%COMP%]{min-width:0}}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}.error[_ngcontent-%COMP%]{display:flex;color:#920000;gap:.25rem}.error[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{height:1rem;width:1rem}@media screen and (min-width: 768px){.grid[_ngcontent-%COMP%]{grid-template-columns:minmax(12rem,.7fr) minmax(12rem,1fr) auto}}.header[_ngcontent-%COMP%]{padding:0}.data[_ngcontent-%COMP%]{align-items:center}.data[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{justify-self:end}.data[_ngcontent-%COMP%] > button[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{width:1rem;height:1rem}"]
      });
    }
  }
  return PendingInvitationsTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var State = /*#__PURE__*/function (State) {
  State[State["LOADING"] = 0] = "LOADING";
  State[State["LOADED"] = 1] = "LOADED";
  State[State["ERROR"] = 2] = "ERROR";
  return State;
}(State || {});
let PendingInvitationsComponent = /*#__PURE__*/(() => {
  class PendingInvitationsComponent {
    constructor() {
      this.destroyRef = inject(DestroyRef);
      this.service = inject(MemberInvitesService);
      this.accessControl = inject(ORG_ACCESS_CONTROLS_TOKEN);
      this.State = State;
      this.currentState = State.LOADED;
    }
    load() {
      this.currentState = State.LOADING;
      this.service.load().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => {
          this.currentState = State.LOADED;
        },
        error: () => {
          this.currentState = State.ERROR;
        }
      });
    }
    static {
      this.ɵfac = function PendingInvitationsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PendingInvitationsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PendingInvitationsComponent,
        selectors: [["fly-orgs-pending-invites"]],
        viewQuery: function PendingInvitationsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invitationModal = _t.first);
          }
        },
        decls: 9,
        vars: 2,
        consts: [["modal", ""], [1, "desc"], ["type", "dark", 1, "loader"], [3, "hidden"], [1, "no-invites"], ["theme", "black", 1, "send-invite-button"], ["theme", "black", 1, "send-invite-button", 3, "click"], [1, "error"], ["icon", "error", 1, "icon"], ["theme", "black", 3, "click"], [1, "refresh-button-content"], ["icon", "refresh-arrows", 1, "icon"]],
        template: function PendingInvitationsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "h2");
            i0.ɵɵtext(2, "PENDING INVITES");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵtext(4, " People who have been invited to join this organization, but who have not yet accepted the invitation. ");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, PendingInvitationsComponent_Case_5_Template, 5, 4)(6, PendingInvitationsComponent_Case_6_Template, 1, 0, "g-loader", 2)(7, PendingInvitationsComponent_Case_7_Template, 12, 0)(8, PendingInvitationsComponent_Conditional_8_Template, 2, 0, "fly-orgs-invitation-modal");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance(5);
            i0.ɵɵconditional((tmp_0_0 = ctx.currentState) === ctx.State.LOADED ? 5 : tmp_0_0 === ctx.State.LOADING ? 6 : tmp_0_0 === ctx.State.ERROR ? 7 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.accessControl.canCreateOrgMembershipInvites() ? 8 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GLoader, InvitationModalComponent, PendingInvitationsTableComponent, IconComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;gap:3.5rem}hr[_ngcontent-%COMP%]{border:1px solid;margin:.5rem 0}.desc[_ngcontent-%COMP%]{padding-left:1rem}.no-invites[_ngcontent-%COMP%]{display:flex;flex-direction:column;color:#737373}.no-invites[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{padding-bottom:1rem}.no-invites[_ngcontent-%COMP%] > .send-invite-button[_ngcontent-%COMP%]{font-size:.875rem;height:1.875rem}.error[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding-top:.5rem;gap:.5rem}.error[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{height:1.5rem;width:1.5rem;color:#920000}.error[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-direction:column}.error[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{padding-bottom:2rem}.loader[_ngcontent-%COMP%]{display:flex;margin:0 auto;width:5rem}.refresh-button-content[_ngcontent-%COMP%]{display:flex;gap:.5rem}.refresh-button-content[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{height:.875rem;width:1.25rem}.hidden[_ngcontent-%COMP%]{display:none}"]
      });
    }
  }
  return PendingInvitationsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EditRolesService = /*#__PURE__*/(() => {
  class EditRolesService {
    constructor() {
      this.memberService = inject(MembersService);
      this.rolesService = inject(RolesService);
      this.addedRoles = signal([]);
      this.removedRoles = signal([]);
      this.customerGuid = signal(null);
      this.member = computed(() => this.memberService.members().find(m => m.customerGuid === this.customerGuid()));
      /** The list of assigned roles = member's current roles - removed roles + added roles */
      this.assignedRoles = computed(() => {
        const member = this.member();
        if (member == null) return [];
        return [...member.roles.filter(r => !this.removedRoles().includes(r)), ...this.addedRoles()];
      });
      /** The list of available roles = all roles - assigned roles - owner role */
      this.availableRoles = computed(() => this.rolesService.roles().filter(role => this.assignedRoles().find(r => r.uuid === role.uuid) == null && role.uuid !== OWNER_ROLE.uuid));
      this.rolesChanged = computed(() => this.addedRoles().length > 0 || this.removedRoles().length > 0);
    }
    init(customerGuid) {
      this.reset();
      this.customerGuid.set(customerGuid);
    }
    addRole(role) {
      const index = this.removedRoles().findIndex(r => r.uuid === role.uuid);
      if (index > -1) {
        this.removedRoles.update(roles => {
          const nextRoles = [...roles];
          nextRoles.splice(index, 1);
          return nextRoles;
        });
      } else {
        this.addedRoles.set([...this.addedRoles(), role]);
      }
    }
    removeRole(role) {
      const index = this.addedRoles().findIndex(r => r.uuid === role.uuid);
      if (index > -1) {
        this.addedRoles.update(roles => {
          const nextRoles = [...roles];
          nextRoles.splice(index, 1);
          return nextRoles;
        });
      } else {
        this.removedRoles.set([...this.removedRoles(), role]);
      }
    }
    save() {
      const member = this.member();
      if (member == null) return throwError(() => new Error('no member selected'));
      return this.memberService.updateRolesForMember(member, this.addedRoles(), this.removedRoles()).pipe(tap({
        complete: () => this.reset()
      }));
    }
    reset() {
      this.addedRoles.set([]);
      this.removedRoles.set([]);
    }
    static {
      this.ɵfac = function EditRolesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EditRolesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EditRolesService,
        factory: EditRolesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EditRolesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddRolesComponent = /*#__PURE__*/(() => {
  class AddRolesComponent {
    constructor() {
      this.editRolesService = inject(EditRolesService);
    }
    onClickAddRoleButton(role) {
      this.editRolesService.addRole(role);
    }
    static {
      this.ɵfac = function AddRolesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddRolesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddRolesComponent,
        selectors: [["fly-orgs-add-roles"]],
        decls: 7,
        vars: 1,
        consts: [[1, "add-roles-container"], [1, "label"], [1, "content"], [1, "empty"], [1, "role-row"], ["title", "Add Role", 1, "icon", "prop-clickable", 3, "click"], ["icon", "plus-circle", 1, "icon", "size-standard", "color-black"]],
        template: function AddRolesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "strong", 1);
            i0.ɵɵtext(2, "Add New Roles");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtemplate(4, AddRolesComponent_Conditional_4_Template, 2, 0, "p", 3);
            i0.ɵɵrepeaterCreate(5, AddRolesComponent_For_6_Template, 6, 1, "div", 4, _forTrack0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.editRolesService.availableRoles().length === 0 ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.editRolesService.availableRoles());
          }
        },
        dependencies: [CommonModule, IconComponent],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.label[_ngcontent-%COMP%]{font-size:1.125rem}.role-row[_ngcontent-%COMP%]{padding:.5rem 1rem;display:flex;justify-content:space-between;background-color:#eee;border-top:1px solid rgb(216.75,216.75,216.75)}.role-row[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#737373;font-size:.875rem}.role-row[_ngcontent-%COMP%]:first-child{border-top:none}.empty[_ngcontent-%COMP%]{color:#737373}.add-roles-container[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column;gap:.5rem}.add-roles-container[_ngcontent-%COMP%] > .content[_ngcontent-%COMP%]{overflow-y:auto}.role-row[_ngcontent-%COMP%]{background-color:#fff}.role-row[_ngcontent-%COMP%]:first-child{border-top:1px solid rgb(216.75,216.75,216.75)}.role-row[_ngcontent-%COMP%]:last-child{border-bottom:1px solid rgb(216.75,216.75,216.75)}"]
      });
    }
  }
  return AddRolesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AssignedRolesComponent = /*#__PURE__*/(() => {
  class AssignedRolesComponent {
    constructor() {
      this.userFirstAndLastName = ['', '']; //TODO: REMOVE THIS VAR AND USE MEMBER SERVICE DATA
      this.editRolesService = inject(EditRolesService);
      this.OWNER_ROLE = OWNER_ROLE;
    }
    onClickRemoveRoleButton(role) {
      this.editRolesService.removeRole(role);
    }
    static {
      this.ɵfac = function AssignedRolesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AssignedRolesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AssignedRolesComponent,
        selectors: [["fly-orgs-assigned-roles"]],
        inputs: {
          userFirstAndLastName: "userFirstAndLastName"
        },
        decls: 8,
        vars: 5,
        consts: [[1, "assigned-roles-container"], [1, "label"], [1, "content"], [1, "empty"], [1, "role-row"], ["title", "Remove Role", 1, "icon", "prop-clickable"], ["title", "Remove Role", 1, "icon", "prop-clickable", 3, "click"], ["icon", "trash-can", 1, "icon", "size-standard", "color-red"]],
        template: function AssignedRolesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "strong", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "flyPossessiveNoun");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵtemplate(5, AssignedRolesComponent_Conditional_5_Template, 2, 0, "p", 3);
            i0.ɵɵrepeaterCreate(6, AssignedRolesComponent_For_7_Template, 5, 2, "div", 4, _forTrack0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(3, 3, ctx.userFirstAndLastName[0]), " Assigned Roles (", ctx.editRolesService.assignedRoles().length, ") ");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.editRolesService.assignedRoles().length === 0 ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.editRolesService.assignedRoles());
          }
        },
        dependencies: [CommonModule, IconComponent, PossessiveNounPipe],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.label[_ngcontent-%COMP%]{font-size:1.125rem}.role-row[_ngcontent-%COMP%]{padding:.5rem 1rem;display:flex;justify-content:space-between;background-color:#eee;border-top:1px solid rgb(216.75,216.75,216.75)}.role-row[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#737373;font-size:.875rem}.role-row[_ngcontent-%COMP%]:first-child{border-top:none}.empty[_ngcontent-%COMP%]{color:#737373}.assigned-roles-container[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column;gap:.5rem}.assigned-roles-container[_ngcontent-%COMP%] > .content[_ngcontent-%COMP%]{overflow-y:auto}@media (hover: hover){.role-row[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{opacity:0}.role-row[_ngcontent-%COMP%]:hover   button[_ngcontent-%COMP%]{opacity:1}}"]
      });
    }
  }
  return AssignedRolesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrgsEditRolesComponent = /*#__PURE__*/(() => {
  class OrgsEditRolesComponent {
    constructor() {
      this.activatedRoute = inject(ActivatedRoute);
      this.destroyRef = inject(DestroyRef);
      this.membersService = inject(MembersService);
      this.editRolesService = inject(EditRolesService);
      this.bannerType = signal(null);
      this.bannerText = computed(() => {
        switch (this.bannerType()) {
          case 'success':
            return 'ROLES UPDATED';
          case 'error':
            return 'UNABLE TO UPDATE ROLES';
          default:
            return null;
        }
      });
    }
    ngOnInit() {
      this.activatedRoute.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
        const member = this.membersService.members().find(m => m.customerGuid === params['id']);
        if (member != null) {
          this.userFirstAndLastName = member.name.split(' ');
          this.editRolesService.init(member.customerGuid);
        }
      });
    }
    onClickSaveRolesButton() {
      this.editRolesService.save().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => this.bannerType.set('success'),
        error: () => this.bannerType.set('error')
      });
    }
    onClickCancelButton() {
      this.bannerType.set(null);
      this.editRolesService.reset();
    }
    closeBanner() {
      this.bannerType.set(null);
    }
    static {
      this.ɵfac = function OrgsEditRolesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgsEditRolesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrgsEditRolesComponent,
        selectors: [["fly-orgs-edit-roles"]],
        decls: 15,
        vars: 11,
        consts: [[1, "orgs-edit-roles-container"], [1, "description"], ["closeable", "false", 3, "click", "show", "type"], [1, "body"], [3, "userFirstAndLastName"], [1, "buttons"], [1, "link-button", 3, "click"], ["theme", "black", 3, "click"]],
        template: function OrgsEditRolesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "header")(2, "h2");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "flyPossessiveNoun");
            i0.ɵɵpipe(5, "uppercase");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "p", 1);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "g-alert", 2);
            i0.ɵɵlistener("click", function OrgsEditRolesComponent_Template_g_alert_click_8_listener() {
              return ctx.closeBanner();
            });
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 3);
            i0.ɵɵelement(11, "fly-orgs-assigned-roles", 4)(12, "fly-orgs-add-roles");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "footer");
            i0.ɵɵtemplate(14, OrgsEditRolesComponent_Conditional_14_Template, 5, 0, "div", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("EDIT ", i0.ɵɵpipeBind1(5, 9, i0.ɵɵpipeBind1(4, 7, ctx.userFirstAndLastName[0])), " ROLES");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" View assigned roles or select new roles you would like to assign to ", ctx.userFirstAndLastName[0] + " " + ctx.userFirstAndLastName[1], ". ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("show", ctx.bannerType() != null)("type", ctx.bannerType());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.bannerText(), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("userFirstAndLastName", ctx.userFirstAndLastName);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.editRolesService.assignedRoles().length > 0 && ctx.editRolesService.rolesChanged() ? 14 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.UpperCasePipe, ComponentsGlobalWebModule, i1.GAlert, i1.GButton, AssignedRolesComponent, AddRolesComponent, PossessiveNounPipe],
        styles: ["[_nghost-%COMP%]{height:100%}.orgs-edit-roles-container[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column;gap:3.5rem}.orgs-edit-roles-container[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 1 auto}.orgs-edit-roles-container[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > .description[_ngcontent-%COMP%]{padding-left:1rem}.orgs-edit-roles-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%]{overflow-y:hidden;display:flex;flex-direction:column;gap:2rem}.orgs-edit-roles-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:50%}@media screen and (min-width: 768px){.orgs-edit-roles-container[_ngcontent-%COMP%] > .body[_ngcontent-%COMP%]{flex-direction:row;gap:4rem}}.orgs-edit-roles-container[_ngcontent-%COMP%] > footer[_ngcontent-%COMP%]{display:flex;justify-content:center}.orgs-edit-roles-container[_ngcontent-%COMP%] > footer[_ngcontent-%COMP%] > .buttons[_ngcontent-%COMP%]{display:flex}.orgs-edit-roles-container[_ngcontent-%COMP%] > footer[_ngcontent-%COMP%] > .buttons[_ngcontent-%COMP%] > .link-button[_ngcontent-%COMP%]{display:flex;align-items:center;padding:.5rem 1.5rem;text-decoration:underline;cursor:pointer}@media screen and (min-width: 768px){.orgs-edit-roles-container[_ngcontent-%COMP%] > footer[_ngcontent-%COMP%]{justify-content:flex-end}}g-alert[_ngcontent-%COMP%]{cursor:pointer;margin-top:1rem}"]
      });
    }
  }
  return OrgsEditRolesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DetailsCardComponent = /*#__PURE__*/(() => {
  class DetailsCardComponent {
    constructor() {
      this.componentState = input('LOADED');
      this.primaryButtonClicked = new EventEmitter();
      this.secondaryButtonClicked = new EventEmitter();
    }
    static {
      this.ɵfac = function DetailsCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DetailsCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DetailsCardComponent,
        selectors: [["fly-details-card"]],
        inputs: {
          title: "title",
          count: "count",
          units: "units",
          additionalText: "additionalText",
          buttonText: "buttonText",
          linkText: "linkText",
          componentState: [1, "componentState"]
        },
        outputs: {
          primaryButtonClicked: "primaryButtonClicked",
          secondaryButtonClicked: "secondaryButtonClicked"
        },
        decls: 6,
        vars: 4,
        consts: [[1, "tiny-heading"], [1, "error-message"], [1, "loader"], ["type", "dark"], [1, "huge-heading"], [1, "small-heading"], ["theme", "black", 1, "primary-button", 3, "click"], ["type", "button"], ["type", "button", 3, "click"]],
        template: function DetailsCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "uppercase");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, DetailsCardComponent_Case_3_Template, 3, 0, "div")(4, DetailsCardComponent_Case_4_Template, 2, 0, "div", 1)(5, DetailsCardComponent_Case_5_Template, 11, 7);
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx.title));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_1_0 = ctx.componentState()) === "LOADING" ? 3 : tmp_1_0 === "ERROR" ? 4 : tmp_1_0 === "LOADED" ? 5 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.UpperCasePipe, ComponentsGlobalWebModule, i1.GButton, i1.GLoader],
        styles: [".tiny-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.tiny-heading[_ngcontent-%COMP%]{font-size:1rem}}.small-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){.small-heading[_ngcontent-%COMP%]{font-size:1.25rem}}.medium-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){.medium-heading[_ngcontent-%COMP%]{font-size:1.5rem}}.big-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){.big-heading[_ngcontent-%COMP%]{font-size:2rem}}.huge-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){.huge-heading[_ngcontent-%COMP%]{font-size:2.5rem}}[_nghost-%COMP%]{background-color:#eee;display:flex;flex-direction:column;padding:1rem;width:20rem;height:100%;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29}.tiny-heading[_ngcontent-%COMP%]{margin:0 0 2rem}div[_ngcontent-%COMP%]{display:flex;align-items:last baseline;gap:.5rem;margin-bottom:1rem}div[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{margin:0}div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#737373;font-size:.875rem}div[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{width:4rem;margin:0 auto}.error-message[_ngcontent-%COMP%]{color:#920000;margin:0 auto}.primary-button[_ngcontent-%COMP%]{margin-bottom:.75rem}button[_ngcontent-%COMP%]{cursor:pointer;margin-top:.5rem;font-size:.75rem;text-decoration:underline;width:fit-content}"]
      });
    }
  }
  return DetailsCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrganizationLandingComponent = /*#__PURE__*/(() => {
  class OrganizationLandingComponent {
    constructor() {
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.memberInvitesService = inject(MemberInvitesService);
      this.selectedOrgService = inject(SelectedOrgService);
      this.destroyRef = inject(DestroyRef);
      this.router = inject(Router);
      this.activatedRoute = inject(ActivatedRoute);
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
      this.membersService = inject(MembersService);
      this.orgAircraftService = inject(OrgAircraftService);
      this.rolesSummariesService = inject(RoleSummariesService);
      this.featuresService = inject(FeaturesService);
      this.aircraftState = signal('LOADING');
      this.membersState = signal('LOADING');
      this.roleSummariesState = signal('LOADING');
      this.aircraftCount = computed(() => this.orgAircraftService.aircraftList().length);
      this.memberCount = computed(() => this.membersService.members().length);
      this.customRoleSummariesCount = computed(() => this.rolesSummariesService.customRoleSummaries().length);
      this.isCustomRolesFeatureActive = toSignal(this.featuresService.isFeatureActive(this.config.site === 'FGA' ? FeatureFlyGarmin.CUSTOM_ROLES : FeatureFlyAdmin.CUSTOM_ROLES), {
        initialValue: false
      });
      this.isNewAircraftListFeatureActive = toSignal(this.featuresService.isFeatureActive(FeatureFlyGarmin.ENABLE_NEW_AIRCRAFT_LIST_PAGE), {
        initialValue: false
      });
      this.name = computed(() => this.selectedOrgService.org()?.name ?? '');
      this.pendingInvitesText = computed(() => {
        const inviteCount = this.memberInvitesService.pendingInvites().length;
        if (!this.accessControls.canViewOrgMembershipInvites() || inviteCount === 0) return undefined;
        return `(${inviteCount} Pending ${inviteCount === 1 ? 'Request' : 'Requests'})`;
      });
      this.addNewAircraftText = computed(() => {
        const canEditOrgAircraft = this.accessControls.canEditOrgAircraft();
        return this.config.site === 'FALA' || !canEditOrgAircraft ? undefined : 'Add a New Aircraft';
      });
      this.loadAircraftEffect = effect(() => {
        if (this.accessControls.canViewOrgAircraft() || this.accessControls.canEditOrgAircraft()) {
          untracked(() => {
            this.aircraftState.set('LOADING');
            if (this.orgAircraftService.isInitialized()) {
              this.aircraftState.set('LOADED');
            } else {
              this.orgAircraftService.load().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                complete: () => this.aircraftState.set('LOADED'),
                error: () => {
                  console.error('Unable to load org aircraft');
                  this.aircraftState.set('ERROR');
                }
              });
            }
          });
        }
      });
      this.loadMembersEffect = effect(() => {
        if (this.accessControls.canViewOrgMemberships() || this.accessControls.canDeleteOrgMemberships()) {
          untracked(() => {
            this.membersState.set('LOADING');
            if (this.membersService.isInitialized()) {
              this.membersState.set('LOADED');
            } else {
              this.membersService.loadMembers().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                complete: () => this.membersState.set('LOADED'),
                error: () => {
                  console.error('Unable to load members');
                  this.membersState.set('ERROR');
                }
              });
            }
          });
        }
      });
      this.loadRoleSummariesEffect = effect(() => {
        if (this.accessControls.canViewOrgRoles() || this.accessControls.canEditOrgRoles()) {
          untracked(() => {
            this.roleSummariesState.set('LOADING');
            if (this.rolesSummariesService.isInitialized()) {
              this.roleSummariesState.set('LOADED');
            } else {
              const loadedObservable = this.rolesSummariesService.load();
              if (loadedObservable != null) {
                loadedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                  complete: () => this.roleSummariesState.set('LOADED'),
                  error: () => {
                    console.error('Unable to load role summaries');
                    this.roleSummariesState.set('ERROR');
                  }
                });
              } else {
                this.roleSummariesState.set('ERROR');
              }
            }
          });
        }
      });
    }
    routeToAddAircraft() {
      this.router.navigate(['/aircraft/manage']);
    }
    routeToAircraftList() {
      if (this.config.site === 'FGA' && this.isNewAircraftListFeatureActive()) {
        this.router.navigate(['aircraft', 'list']);
      } else {
        this.router.navigate(['./aircraft'], {
          relativeTo: this.activatedRoute
        });
      }
    }
    static {
      this.ɵfac = function OrganizationLandingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrganizationLandingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrganizationLandingComponent,
        selectors: [["fly-orgs-landing"]],
        viewQuery: function OrganizationLandingComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invitationModal = _t.first);
          }
        },
        decls: 12,
        vars: 8,
        consts: [["modal", ""], [1, "tiny-heading"], [1, "huge-heading"], [1, "details"], ["title", "People", 3, "count", "componentState", "units", "additionalText", "buttonText", "linkText"], ["title", "Aircraft", "units", "Aircraft", 3, "count", "componentState", "buttonText", "linkText"], ["title", "Roles", 3, "count", "componentState", "units", "buttonText", "linkText"], [3, "click"], [1, "settings-button"], ["icon", "gear", 1, "icon"], ["title", "People", 3, "primaryButtonClicked", "secondaryButtonClicked", "count", "componentState", "units", "additionalText", "buttonText", "linkText"], ["title", "Aircraft", "units", "Aircraft", 3, "primaryButtonClicked", "secondaryButtonClicked", "count", "componentState", "buttonText", "linkText"], ["title", "Roles", 3, "primaryButtonClicked", "secondaryButtonClicked", "count", "componentState", "units", "buttonText", "linkText"]],
        template: function OrganizationLandingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "p", 1);
            i0.ɵɵtext(2, "ORGANIZATION");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p", 2);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "uppercase");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, OrganizationLandingComponent_Conditional_6_Template, 4, 0, "g-button");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 3);
            i0.ɵɵtemplate(8, OrganizationLandingComponent_Conditional_8_Template, 1, 6, "fly-details-card", 4)(9, OrganizationLandingComponent_Conditional_9_Template, 1, 4, "fly-details-card", 5)(10, OrganizationLandingComponent_Conditional_10_Template, 1, 5, "fly-details-card", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, OrganizationLandingComponent_Conditional_11_Template, 2, 0, "fly-orgs-invitation-modal");
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, ctx.name()));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.accessControls.canEditOrgSettings() ? 6 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.accessControls.canViewOrgMemberships() || ctx.accessControls.canDeleteOrgMemberships() ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.accessControls.canViewOrgAircraft() || ctx.accessControls.canEditOrgAircraft() ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.accessControls.canViewOrgRoles() || ctx.accessControls.canEditOrgRoles()) && ctx.isCustomRolesFeatureActive() ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.accessControls.canCreateOrgMembershipInvites() ? 11 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.UpperCasePipe, ComponentsGlobalWebModule, i1.GButton, DetailsCardComponent, IconComponent, InvitationModalComponent],
        styles: [".tiny-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){.tiny-heading[_ngcontent-%COMP%]{font-size:1rem}}.small-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){.small-heading[_ngcontent-%COMP%]{font-size:1.25rem}}.medium-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){.medium-heading[_ngcontent-%COMP%]{font-size:1.5rem}}.big-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){.big-heading[_ngcontent-%COMP%]{font-size:2rem}}.huge-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){.huge-heading[_ngcontent-%COMP%]{font-size:2.5rem}}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:3rem}.tiny-heading[_ngcontent-%COMP%]{color:#737373;margin:0}.huge-heading[_ngcontent-%COMP%]{margin:.5rem 0 1rem;padding-bottom:.75rem;border-bottom:1px solid rgb(229.5,229.5,229.5);width:fit-content}.settings-button[_ngcontent-%COMP%]{display:flex;justify-content:space-between;gap:.25rem}.settings-button[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:10px;height:10px}.details[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fit,20rem);gap:1.5rem;justify-content:center}"]
      });
    }
  }
  return OrganizationLandingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This service is responsible for computing the set of members that are
 * actually displayed in the members table with sorting, filtering, and pagination
 * applied.
 */
let MembersTableService = /*#__PURE__*/(() => {
  class MembersTableService {
    sortMembers(col, value) {
      if (col === 'name') {
        if (value != null) {
          this.sortDirName.set(value);
        } else {
          this.sortDirName.update(prev => prev === 0 ? 1 : prev * -1);
        }
        this.sortBySelection.setValue(this.sortDirName() === 1 ? 'Name - ASC' : 'Name - DESC', {
          emitEvent: false
        });
        this.sortDirEmail.set(0);
      }
      if (col === 'email') {
        if (value != null) {
          this.sortDirEmail.set(value);
        } else {
          this.sortDirEmail.update(prev => prev === 0 ? 1 : prev * -1);
        }
        this.sortBySelection.setValue(this.sortDirEmail() === 1 ? 'Email - ASC' : 'Email - DESC', {
          emitEvent: false
        });
        this.sortDirName.set(0);
      }
    }
    constructor() {
      this.membersService = inject(MembersService);
      this.searchInput = new FormControl(null);
      this.searchText = toSignal(this.searchInput.valueChanges, {
        initialValue: null
      });
      this.roleSelection = new FormControl('', {
        nonNullable: true
      });
      this.role = toSignal(this.roleSelection.valueChanges, {
        initialValue: ''
      });
      this.sortDirName = signal(1);
      this.sortDirEmail = signal(0);
      // this is for small screens only since we only have one column in this case
      this.sortBySelection = new FormControl('Name - ASC', {
        nonNullable: true
      });
      this.ROW_LIMIT = 5;
      this.currentPage = signal(1);
      this.totalPages = computed(() => Math.ceil(this.filteredMembers().length / this.ROW_LIMIT));
      this.showAll = signal(false);
      this.filteredMembers = computed(() => {
        let members = this.membersService.members();
        const search = this.searchText()?.toLowerCase();
        const role = this.role();
        if (search != null) {
          members = members.filter(m => m.name.toLowerCase().includes(search));
        }
        if (role !== '') {
          members = members.filter(m => m.roles.map(r => r.uuid).includes(role));
        }
        members = [...members].sort((a, b) => {
          const nameSort = a.name.localeCompare(b.name) * this.sortDirName();
          if (nameSort !== 0) return nameSort;
          const emailSort = a.email.localeCompare(b.email) * this.sortDirEmail();
          return emailSort;
        });
        return members;
      });
      /** The set of members on the current page, which have a special `selected` attribute. */
      this.currentPageMembers = computed(() => {
        const members = this.filteredMembers().map(m => ({
          ...m,
          selected: false
        }));
        if (this.showAll()) return members;
        // `currentPage` starts from 1 but we need to use it here to slice an array (which starts from 0)
        const start = (this.currentPage() - 1) * this.ROW_LIMIT;
        return members.slice(start, start + this.ROW_LIMIT);
      });
      // any time `filteredMembers` is recomputed, we want to reset `currentPage`
      effect(() => {
        this.filteredMembers(); // just read this signal so we get change detection
        untracked(() => {
          this.currentPage.set(1);
        });
      });
      this.sortBySelection.valueChanges.pipe(takeUntilDestroyed()).subscribe(value => {
        switch (value) {
          case 'Name - ASC':
            this.sortMembers('name', 1);
            break;
          case 'Name - DESC':
            this.sortMembers('name', -1);
            break;
          case 'Email - ASC':
            this.sortMembers('email', 1);
            break;
          case 'Email - DESC':
            this.sortMembers('email', -1);
            break;
          default:
            break;
        }
      });
    }
    static {
      this.ɵfac = function MembersTableService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembersTableService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MembersTableService,
        factory: MembersTableService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MembersTableService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RolesCellComponent = /*#__PURE__*/(() => {
  class RolesCellComponent {
    constructor() {
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
      this.otherRoles = [];
    }
    ngOnInit() {
      this.isOwner = this.member.roles.some(role => role.uuid === OWNER_ROLE.uuid);
      this.displayedRole = this.member.roles.find(role => role.uuid === OWNER_ROLE.uuid) ?? this.member.roles.at(0);
      this.otherRoles = this.member.roles.filter(role => role.uuid !== this.displayedRole.uuid);
    }
    static {
      this.ɵfac = function RolesCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RolesCellComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RolesCellComponent,
        selectors: [["fly-roles-cell"]],
        inputs: {
          member: "member"
        },
        decls: 5,
        vars: 2,
        consts: [["heading", ""], [1, "g-collapsible-region", 3, "expanded"], [3, "routerLink"], [1, "role"], [1, "more"], [4, "ngTemplateOutlet"], ["slot", "heading", 1, "text"], ["slot", "body"]],
        template: function RolesCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, RolesCellComponent_ng_template_0_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, RolesCellComponent_Conditional_2_Template, 1, 1, "ng-container")(3, RolesCellComponent_Conditional_3_Template, 6, 2, "g-collapsible-region", 1)(4, RolesCellComponent_Conditional_4_Template, 2, 1, "a", 2);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.otherRoles.length === 0 ? 2 : 3);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.isOwner && ctx.accessControls.canCreateOrgMemberships() && ctx.accessControls.canDeleteOrgMemberships() ? 4 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgTemplateOutlet, RouterLink, ComponentsGlobalWebModule, i1.GCollapsibleRegion],
        styles: [".ellipsis[_ngcontent-%COMP%], .role[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}[_nghost-%COMP%]{-webkit-user-select:none;user-select:none}.more[_ngcontent-%COMP%]{font-size:.875rem}a[_ngcontent-%COMP%]{font-size:.875rem;display:block}.g-collapsible-region[_ngcontent-%COMP%]{margin:unset}.text[_ngcontent-%COMP%]{display:flex;gap:.5rem;align-items:center}.text[_ngcontent-%COMP%] > .role[_ngcontent-%COMP%]{flex:1 1 auto}.text[_ngcontent-%COMP%] > .more[_ngcontent-%COMP%]{flex:0 0 auto}"]
      });
    }
  }
  return RolesCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MembersTableComponent = /*#__PURE__*/(() => {
  class MembersTableComponent {
    constructor() {
      this.membersService = inject(MembersService);
      this.membersTableService = inject(MembersTableService);
      this.rolesService = inject(RolesService);
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
      this.libConfig = inject(FLY_WEB_COMMON_CONFIG);
      this.searchInput = this.membersTableService.searchInput;
      this.roleSelection = this.membersTableService.roleSelection;
      this.sortByOptions = ['Name - ASC', 'Name - DESC', 'Email - ASC', 'Email - DESC'];
      this.orgOwnerIndex = computed(() => this.membersTableService.currentPageMembers().findIndex(member => member.isOwner));
      this.memberRemoveState = signal('UNSET');
      this.state = signal('LOADING');
      this.memberToRemove = null;
      this.destroyRef = inject(DestroyRef);
      this.onConfirmRemoval = () => {
        this.memberRemoveState.set('LOADING');
        if (this.memberToRemove == null) {
          console.error('No member found to remove.');
          this.memberRemoveState.set('ERROR');
        } else {
          this.membersService.deleteMember(this.memberToRemove.customerGuid).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            complete: () => {
              this.memberRemoveState.set('LOADED');
              this.modal.close();
            },
            error: () => this.memberRemoveState.set('ERROR')
          });
        }
      };
      this.onCloseRemoveModal = () => {
        this.modal.close();
        // The focus state of the 'Remove' button persists even after closing the modal. Manually remove the focus.
        this.buttons.forEach(button => button.removeFocus());
      };
    }
    ngOnInit() {
      if (this.membersService.isInitialized()) {
        this.state.set('LOADED');
      } else {
        this.loadMembers();
      }
    }
    loadMembers() {
      this.state.set('LOADING');
      this.membersService.loadMembers().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => this.state.set('LOADED'),
        error: () => this.state.set('ERROR')
      });
    }
    removeMember(member) {
      this.memberRemoveState.set('UNSET');
      this.memberToRemove = member;
      this.modal.open();
    }
    static {
      this.ɵfac = function MembersTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembersTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MembersTableComponent,
        selectors: [["fly-members-table"]],
        viewQuery: function MembersTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(GButton, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttons = _t);
          }
        },
        decls: 7,
        vars: 15,
        consts: [["modal", ""], ["type", "dark", 1, "loader"], [1, "error"], [3, "header", "buttons", "showCloseBtn"], [1, "remove-error-text"], [1, "grid"], [1, "row", "controls"], ["label", "Search by Name", 1, "search", 3, "inputControl"], ["label", "Filter by Role", 1, "filter"], ["name", "role-select", 3, "formControl"], ["selected", "", "value", ""], [3, "value"], ["label", "Sort By", 1, "sort-by"], ["name", "sort-by-select", 3, "formControl"], [1, "row", "header"], ["colName", "Name", 1, "label", 3, "click", "sortDir"], ["colName", "Email", 1, "label", 3, "click", "sortDir"], [1, "label"], [1, "refresh-btn", 3, "click"], ["icon", "refresh-arrows", 1, "icon"], ["label", "Active Members", 3, "count", "total", "currentPage", "totalPages", "showAll"], [1, "no-results"], [1, "row", "data"], [1, "ellipsis"], [3, "member"], [1, "control-buttons"], ["size", "small", 3, "click"], [1, "control-button-text"], ["icon", "error", 1, "icon", "size-large", "color-red"], [1, "desc"], [1, "text"], ["theme", "black", 3, "click"], [1, "button-contents"], ["icon", "refresh-arrows", 1, "icon", "size-standard", "color-white"]],
        template: function MembersTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MembersTableComponent_Conditional_0_Template, 23, 7)(1, MembersTableComponent_Conditional_1_Template, 1, 0, "g-loader", 1)(2, MembersTableComponent_Conditional_2_Template, 11, 0, "div", 2);
            i0.ɵɵelementStart(3, "fly-modal", 3, 0);
            i0.ɵɵtemplate(5, MembersTableComponent_Case_5_Template, 2, 0, "p", 4)(6, MembersTableComponent_Case_6_Template, 2, 0, "span");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_7_0;
            i0.ɵɵconditional(ctx.state() !== "ERROR" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.state() === "LOADING" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.state() === "ERROR" ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("header", "Are you sure you want to remove ", ctx.memberToRemove == null ? null : ctx.memberToRemove.name, "?");
            i0.ɵɵproperty("buttons", i0.ɵɵpureFunction2(12, _c3, i0.ɵɵpureFunction1(8, _c1, ctx.onCloseRemoveModal), i0.ɵɵpureFunction1(10, _c2, ctx.onConfirmRemoval)))("showCloseBtn", false);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_7_0 = ctx.memberRemoveState()) === "ERROR" ? 5 : tmp_7_0 === "LOADING" ? 6 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GDropDown, i1.GLoader, ModalComponent, FormsModule, i2.NgSelectOption, i2.ɵNgSelectMultipleOption, i2.SelectControlValueAccessor, i2.NgControlStatus, ReactiveFormsModule, i2.FormControlDirective, SortableColumnHeaderComponent, SearchInputComponent, PageControlsComponent, RolesCellComponent, IconComponent],
        styles: [".refresh-btn[_ngcontent-%COMP%]{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}.header[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem}.ellipsis[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:auto}.header[_ngcontent-%COMP%]{text-transform:uppercase;border-bottom:2px solid #000;-webkit-user-select:none;user-select:none}.header[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.header[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{display:flex;height:fit-content;padding:1rem}}.row[_ngcontent-%COMP%]{display:grid;grid-column:1/-1;grid-template-columns:auto;grid-template-rows:repeat(auto-fit,minmax(0,max-content));gap:.25rem;padding:1rem}@media screen and (min-width: 768px){.row[_ngcontent-%COMP%]{grid-template-columns:subgrid;grid-template-rows:subgrid;gap:0;padding:0}}.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:0}@media screen and (min-width: 768px){.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:1rem}}.single-item-row[_ngcontent-%COMP%]{grid-column:1/-1}.hidden[_ngcontent-%COMP%]{display:none}.data[_ngcontent-%COMP%]{border-bottom:1px solid rgb(216.75,216.75,216.75)}.control-buttons[_ngcontent-%COMP%]{justify-self:end;display:flex;flex-direction:column;justify-content:flex-end;gap:.5rem}.control-buttons[_ngcontent-%COMP%]   .control-button-text[_ngcontent-%COMP%]{display:inline-block;min-width:3rem}@media screen and (min-width: 768px){.control-buttons[_ngcontent-%COMP%]{flex-direction:row}.control-buttons[_ngcontent-%COMP%]   .control-button-text[_ngcontent-%COMP%]{min-width:0}}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}button[_ngcontent-%COMP%]{cursor:pointer}.no-results[_ngcontent-%COMP%]{margin-top:.5rem;color:#737373}.error[_ngcontent-%COMP%]{display:flex;border-top:3px solid #000;padding-top:1rem;margin-top:2rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-left:1rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%] > .text[_ngcontent-%COMP%]{margin-bottom:1.25rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%]   .button-contents[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%]   .button-contents[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{margin-right:.5rem}.error[_ngcontent-%COMP%] > .desc[_ngcontent-%COMP%] > .loader[_ngcontent-%COMP%]{width:4rem}@media screen and (min-width: 768px){.grid[_ngcontent-%COMP%]{grid-template-columns:repeat(2,.7fr) minmax(12rem,1fr) max-content}}.refresh-btn[_ngcontent-%COMP%]{letter-spacing:.05rem;color:#106fad;width:fit-content;display:flex;gap:.25rem;align-items:center;justify-self:flex-end}.refresh-btn[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{fill:#106fad;width:1rem;height:1rem}@media screen and (min-width: 768px){.search[_ngcontent-%COMP%]{grid-column:1}}@media screen and (min-width: 768px){.filter[_ngcontent-%COMP%]{grid-column:3}}.sort-by[_ngcontent-%COMP%]{display:inline}@media screen and (min-width: 768px){.sort-by[_ngcontent-%COMP%]{display:none}}.remove-error-text[_ngcontent-%COMP%]{display:flex;margin-top:.5rem;color:#920000;justify-content:center}.loader[_ngcontent-%COMP%]{display:flex;margin:0 auto;width:5rem}"]
      });
    }
  }
  return MembersTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrgsMembersComponent = /*#__PURE__*/(() => {
  class OrgsMembersComponent {
    constructor() {
      this.membersService = inject(MembersService);
      this.membersTableService = inject(MembersTableService);
      this.accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
    }
    static {
      this.ɵfac = function OrgsMembersComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrgsMembersComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrgsMembersComponent,
        selectors: [["fly-orgs-members"]],
        viewQuery: function OrgsMembersComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invitationModal = _t.first);
          }
        },
        decls: 9,
        vars: 4,
        consts: [["modal", ""], [1, "top-desc"], [1, "invite-controls"], ["size", "medium", "theme", "dark", 1, "send-invite-btn"], ["routerLink", "./pending-invites"], ["size", "medium", "theme", "dark", 1, "send-invite-btn", 3, "click"]],
        template: function OrgsMembersComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "h2");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 1)(4, "p");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, OrgsMembersComponent_Conditional_6_Template, 3, 2, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "fly-members-table");
            i0.ɵɵtemplate(8, OrgsMembersComponent_Conditional_8_Template, 2, 0, "fly-orgs-invitation-modal");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", ctx.accessControls.canDeleteOrgMemberships() ? "MANAGE" : "VIEW", " ORGANIZATION MEMBERS");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" Here you can ", ctx.accessControls.canDeleteOrgMemberships() ? "access and manage" : "view", " all of the information about your organization\u2019s members. ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.accessControls.canCreateOrgMembershipInvites() || ctx.accessControls.canViewOrgMembershipInvites() ? 6 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.accessControls.canCreateOrgMembershipInvites() ? 8 : -1);
          }
        },
        dependencies: [CommonModule, RouterLink, ComponentsGlobalWebModule, i1.GButton, MembersTableComponent, InvitationModalComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}.top-desc[_ngcontent-%COMP%]{padding-left:1rem;display:flex;flex-direction:column;gap:1rem}.send-invite-btn[_ngcontent-%COMP%]{margin:1.5rem 0}.invite-controls[_ngcontent-%COMP%]{display:flex;gap:1rem;align-items:baseline}"]
      });
    }
  }
  return OrgsMembersComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const accessControlGuard = route => {
  const accessControls = inject(ORG_ACCESS_CONTROLS_TOKEN);
  const router = inject(Router);
  const accessControlSignalProperty = route.data['accessControlSignalProperty'];
  const accessControlSignalProperties = route.data['accessControlSignalProperties'];
  if (accessControlSignalProperty == null === (accessControlSignalProperties == null)) {
    return false;
  }
  const properties = accessControlSignalProperties ?? [accessControlSignalProperty];
  return accessControls.areAccessControlsReady().pipe(filter(areAccessControlsReady => areAccessControlsReady), take(1), timeout(5000), map(() => {
    for (const property of properties) {
      if (property in accessControls && accessControls[property]() === true) {
        return true;
      }
    }
    return false;
  }), catchError(() => {
    console.error('The access controls failed to load');
    return of(false);
  }), map(success => {
    if (!success) {
      if (route.data['redirectTo'] != null && Array.isArray(route.data['redirectTo'])) {
        return router.createUrlTree(route.data['redirectTo']);
      } else {
        return router.createUrlTree(['/denied']);
      }
    }
    return true;
  }));
};
const editMemberRolesGuard = route => {
  const uuid = route.paramMap.get('id');
  const router = inject(Router);
  if (uuid == null) {
    return of(router.createUrlTree(['/not-found']));
  }
  const membersService = inject(MembersService);
  const loadMembers$ = membersService.isInitialized() ? EMPTY : membersService.loadMembers();
  return loadMembers$.pipe(isEmpty(), switchMap(() => {
    const uuidIsMember = membersService.members().find(m => m.customerGuid === uuid);
    return uuidIsMember == null ? throwError(() => new Error('Unable to find the member.')) : of(true);
  }), catchError(() => of(router.createUrlTree(['/not-found']))));
};

/**
 * This guard ensures that an org UUID is available for the `OrgComponent` and its
 * routes.
 */
const orgGuard = route => {
  // the org uuid should come from either the route param or the org cookie
  let uuid = route.paramMap.get('orgUuid') ?? inject(GarminGlobalStoreService).getGlobal('org.uuid');
  uuid = uuid !== undefined ? uuid : null;
  // set the selected org so all of the services that care about this get updates
  const router = inject(Router);
  return inject(SelectedOrgService).selectOrg(uuid).pipe(catchError(() => {
    console.error('An error occurred while fetching the organization.');
    return of(false);
  }), map(isOrgSelected => {
    if (isOrgSelected) {
      return true; // allow navigation
    }
    return router.createUrlTree(['/not-found']);
  }));
};
const editCustomRoleGuard = route => {
  const uuid = route.paramMap.get('id');
  const router = inject(Router);
  if (uuid == null) {
    return router.createUrlTree(['/not-found']);
  }
  const roleSummaryService = inject(RoleSummariesService);
  const loadRoleSummaries$ = roleSummaryService.isInitialized() ? EMPTY : roleSummaryService.load();
  return loadRoleSummaries$.pipe(isEmpty(), switchMap(() => {
    const roleToEdit = roleSummaryService.getRoleById(uuid, false);
    if (roleToEdit == null) {
      return throwError(() => new Error('Unable to find the custom role.'));
    }
    return of(true);
  }), catchError(() => {
    return of(router.createUrlTree(['/not-found']));
  }));
};

/**
 * Generates the routes for the org management tool in FGA.
 *
 * @note A custom settings component _must_ be provided.
 */
const orgRoutes = (path, settingsComponent) => ({
  path,
  component: OrgComponent,
  canActivate: [orgGuard],
  children: [{
    path: '',
    component: OrganizationLandingComponent,
    canActivate: [accessControlGuard],
    data: {
      // Enabled the page if one of the access properties is set to true.
      accessControlSignalProperties: ['canViewOrgMemberships', 'canViewOrgAircraft', 'canViewOrgRoles', 'canEditOrgSettings', 'canDeleteOrgMemberships', 'canEditOrgAircraft', 'canEditOrgRoles'],
      breadcrumbs: ['HOME']
    }
  },
  // NOTE: these two pages are at the same level as 'HOME' so going "back" is routing to the same level without a path element
  {
    path: 'settings',
    component: settingsComponent,
    canActivate: [accessControlGuard],
    data: {
      accessControlSignalProperty: 'canEditOrgSettings',
      breadcrumbs: ['SETTINGS'],
      back: './'
    }
  }, {
    path: 'members',
    component: OrgsMembersComponent,
    canActivate: [accessControlGuard],
    data: {
      accessControlSignalProperties: ['canViewOrgMemberships', 'canCreateOrgMemberships', 'canDeleteOrgMemberships'],
      breadcrumbs: ['MEMBERS'],
      back: './'
    }
  }, {
    path: 'roles',
    component: OrgsCustomRolesComponent,
    canActivate: [accessControlGuard],
    data: {
      accessControlSignalProperties: ['canViewOrgRoles', 'canEditOrgRoles'],
      breadcrumbs: ['ROLES'],
      back: './'
    }
  },
  // NOTE: these are not children of 'members' because children are rendered in a router-outlet ('members' has no router-outlet)
  {
    path: 'members/edit-roles/:id',
    component: OrgsEditRolesComponent,
    canActivate: [accessControlGuard, editMemberRolesGuard],
    data: {
      accessControlSignalProperties: ['canCreateOrgMemberships', 'canDeleteOrgMemberships'],
      breadcrumbs: ['MEMBERS', 'EDIT ROLES'],
      back: 'members'
    }
  }, {
    path: 'members/pending-invites',
    component: PendingInvitationsComponent,
    canActivate: [accessControlGuard],
    data: {
      accessControlSignalProperty: 'canViewOrgMembershipInvites',
      breadcrumbs: ['MEMBERS', 'PENDING INVITES'],
      back: 'members'
    }
  },
  // NOTE: these are not children of 'roles' because children are rendered in a router-outlet ('roles' has no router-outlet)
  {
    path: 'roles/create',
    component: RoleWizardComponent,
    canActivate: [accessControlGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      accessControlSignalProperty: 'canEditOrgRoles',
      breadcrumbs: ['CREATE NEW ROLE'],
      back: './'
    }
  }, {
    path: 'roles/edit/:id',
    component: RoleWizardComponent,
    canActivate: [accessControlGuard, editCustomRoleGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      accessControlSignalProperty: 'canEditOrgRoles',
      breadcrumbs: ['UPDATE ROLE'],
      back: './'
    }
  }]
});
/**
 * Generates the routes for the org management tool in FALA.
 *
 * @note A custom settings component _must_ be provided.
 *
 * @note The difference between this and `orgRoutes` is that the path provided is appened
 * with the `orgUuid` path parameter.
 */
const orgAdminRoutes = (path, settingsComponent) => orgRoutes(path === '' ? ':orgUuid' : `${path}/:orgUuid`, settingsComponent);

/*
 * Public API surface of `orgs`
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractOrgSettingsService, BasicOrgSettingsComponent, CreateOrganizationComponent, EXCLUDE_ORG_CONTEXT_ID, MEMBER_ROLE, MembersService, ORG_ACCESS_CONTROLS_TOKEN, ORG_SETTINGS_SERVICE_TOKEN, OWNER_ROLE, OrgAircraftService, OrgComponent, OrgContextInterceptorService, OrgContextOptionsService, OrganizationsService, OrgsCustomRolesComponent, OrgsSelectorComponent, RoleSummariesService, RoleWizardComponent, RolesService, SelectedOrgFunctionsService, SelectedOrgService, orgAdminRoutes, orgRoutes };
